<template>
      <div class="g-doc">
          <div class="table-of-contents"><ul><li><a href="#u9274u6743u76f8u5173u8bf4u660e">鉴权相关说明</a><ul><li><a href="#u751fu6210token0a3ca20id3du751fu6210token63203e203ca3e">生成Token
<a id=生成Token6320> </a></a></li><li><a href="#u9274u6743u76f8u5173u9519u8befu78010a3ca20id3du9274u6743u76f8u5173u9519u8befu780163203e203ca3e">鉴权相关错误码
<a id=鉴权相关错误码6320> </a></a></li></ul></li><li><a href="#u9519u8befu8fd4u56deu7801">错误返回码</a><ul><li><a href="#u8fd4u56deu78010a3ca20id3du8fd4u56deu780163273e203ca3e">返回码
<a id=返回码6327> </a></a></li></ul></li><li><a href="#u90e8u95e8u76f8u5173u63a5u53e3">部门相关接口</a><ul><li><a href="#u4feeu6539u7ec4u7ec7u67b6u67840a3ca20id3du4feeu6539u7ec4u7ec7u67b6u678463343e203ca3e">修改组织架构
<a id=修改组织架构6334> </a></a></li><li><a href="#u5206u9875u67e5u8be2u7ec4u7ec7u67b6u67840a3ca20id3du5206u9875u67e5u8be2u7ec4u7ec7u67b6u678463343e203ca3e">分页查询组织架构
<a id=分页查询组织架构6334> </a></a></li><li><a href="#u521bu5efau7ec4u7ec7u67b6u67840a3ca20id3du521bu5efau7ec4u7ec7u67b6u678463343e203ca3e">创建组织架构
<a id=创建组织架构6334> </a></a></li><li><a href="#u5220u9664u7ec4u7ec7u67b6u67840a3ca20id3du5220u9664u7ec4u7ec7u67b6u678463343e203ca3e">删除组织架构
<a id=删除组织架构6334> </a></a></li></ul></li><li><a href="#u7528u6237u76f8u5173u63a5u53e3">用户相关接口</a><ul><li><a href="#u4feeu6539u7528u6237u4fe1u606f0a3ca20id3du4feeu6539u7528u6237u4fe1u606f63413e203ca3e">修改用户信息
<a id=修改用户信息6341> </a></a></li><li><a href="#u5220u9664u7528u6237u4fe1u606f0a3ca20id3du5220u9664u7528u6237u4fe1u606f63413e203ca3e">删除用户信息
<a id=删除用户信息6341> </a></a></li><li><a href="#u6279u91cfu6ce8u518cu7528u62370a3ca20id3du6279u91cfu6ce8u518cu7528u623763413e203ca3e">批量注册用户
<a id=批量注册用户6341> </a></a></li><li><a href="#u65b0u589eu7528u6237u4fe1u606f0a3ca20id3du65b0u589eu7528u6237u4fe1u606f63413e203ca3e">新增用户信息
<a id=新增用户信息6341> </a></a></li><li><a href="#u67e5u8be2u7528u6237u4fe1u606f0a3ca20id3du67e5u8be2u7528u6237u4fe1u606f63413e203ca3e">查询用户信息
<a id=查询用户信息6341> </a></a></li><li><a href="#u83b7u53d6u7528u6237u5728u7ebfu60c5u51b50a3ca20id3du83b7u53d6u7528u6237u5728u7ebfu60c5u51b563413e203ca3e">获取用户在线情况
<a id=获取用户在线情况6341> </a></a></li></ul></li><li><a href="#u4f1au8baeu76f8u5173u63a5u53e3">会议相关接口</a><ul><li><a href="#u4e0bu8f7du4f1au8baeu7eaau89810a3ca20id3du4e0bu8f7du4f1au8baeu7eaau898163483e203ca3e">下载会议纪要
<a id=下载会议纪要6348> </a></a></li><li><a href="#u83b7u53d6u4f1au63a7u5730u57400a3ca20id3du83b7u53d6u4f1au63a7u5730u574063483e203ca3e">获取会控地址
<a id=获取会控地址6348> </a></a></li><li><a href="#u83b7u53d6u4f1au8baeu7eaau89810a3ca20id3du83b7u53d6u4f1au8baeu7eaau898163483e203ca3e">获取会议纪要
<a id=获取会议纪要6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5f55u5236u914du7f6e0a3ca20id3du4feeu6539u4f1au8baeu5f55u5236u914du7f6e63483e203ca3e">修改会议录制配置
<a id=修改会议录制配置6348> </a></a></li><li><a href="#u521bu5efau5373u65f6u4f1au8baeu5ba40a3ca20id3du521bu5efau5373u65f6u4f1au8baeu5ba463483e203ca3e">创建即时会议室
<a id=创建即时会议室6348> </a></a></li><li><a href="#u6279u91cfu65b0u589eu4f1au8baeu5ba40a3ca20id3du6279u91cfu65b0u589eu4f1au8baeu5ba463483e203ca3e">批量新增会议室
<a id=批量新增会议室6348> </a></a></li><li><a href="#u65b0u589eu4f1au8baeu5ba40a3ca20id3du65b0u589eu4f1au8baeu5ba463483e203ca3e">新增会议室
<a id=新增会议室6348> </a></a></li><li><a href="#u67e5u8be2u4f1au8baeu5f55u5236u914du7f6e0a3ca20id3du67e5u8be2u4f1au8baeu5f55u5236u914du7f6e63483e203ca3e">查询会议录制配置
<a id=查询会议录制配置6348> </a></a></li><li><a href="#u7ed9u7528u6237u6388u6743u4f1au8baeu5ba40a3ca20id3du7ed9u7528u6237u6388u6743u4f1au8baeu5ba463483e203ca3e">给用户授权会议室
<a id=给用户授权会议室6348> </a></a></li><li><a href="#u7ed9u4f1au8baeu5ba4u6388u6743u7528u62370a3ca20id3du7ed9u4f1au8baeu5ba4u6388u6743u7528u623763483e203ca3e">给会议室授权用户
<a id=给会议室授权用户6348> </a></a></li><li><a href="#u8bf7u51fau7528u62370a3ca20id3du8bf7u51fau7528u623763483e203ca3e">请出用户
<a id=请出用户6348> </a></a></li><li><a href="#u5220u9664u4f1au8baeu5ba40a3ca20id3du5220u9664u4f1au8baeu5ba463483e203ca3e">删除会议室
<a id=删除会议室6348> </a></a></li><li><a href="#u6e05u7a7au4f1au8baeu5ba40a3ca20id3du6e05u7a7au4f1au8baeu5ba463483e203ca3e">清空会议室
<a id=清空会议室6348> </a></a></li><li><a href="#u66f4u65b0u4f1au8baeu5ba4u72b6u60010a3ca20id3du66f4u65b0u4f1au8baeu5ba4u72b6u600163483e203ca3e">更新会议室状态
<a id=更新会议室状态6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u5e03u5c400a3ca20id3du4feeu6539u4f1au8baeu5ba4u5e03u5c4063483e203ca3e">修改会议室布局
<a id=修改会议室布局6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u57fau672cu53c2u65700a3ca20id3du4feeu6539u4f1au8baeu5ba4u57fau672cu53c2u657063483e203ca3e">修改会议室基本参数
<a id=修改会议室基本参数6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u6a21u677f0a3ca20id3du4feeu6539u4f1au8baeu5ba4u6a21u677f63483e203ca3e">修改会议室模板
<a id=修改会议室模板6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u4e3au5468u4f8bu4f1au8baeu5ba40a3ca20id3du4feeu6539u4f1au8baeu5ba4u4e3au5468u4f8bu4f1au8baeu5ba463483e203ca3e">修改会议室为周例会议室
<a id=修改会议室为周例会议室6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u4e3au9884u7ea6u4f1au8baeu5ba40a3ca20id3du4feeu6539u4f1au8baeu5ba4u4e3au9884u7ea6u4f1au8baeu5ba463483e203ca3e">修改会议室为预约会议室
<a id=修改会议室为预约会议室6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u4e3au56fau5b9au4f1au8baeu5ba40a3ca20id3du4feeu6539u4f1au8baeu5ba4u4e3au56fau5b9au4f1au8baeu5ba463483e203ca3e">修改会议室为固定会议室
<a id=修改会议室为固定会议室6348> </a></a></li><li><a href="#u4feeu6539u4f1au8baeu5ba4u662fu5426u542fu7528u9ed8u8ba4u89c6u9891u914du7f6e0a3ca20id3du4feeu6539u4f1au8baeu5ba4u662fu5426u542fu7528u9ed8u8ba4u89c6u9891u914du7f6e63483e203ca3e">修改会议室是否启用默认视频配置
<a id=修改会议室是否启用默认视频配置6348> </a></a></li><li><a href="#u83b7u53d6u4f1au8baeu5ba4u5217u88680a3ca20id3du83b7u53d6u4f1au8baeu5ba4u5217u886863483e203ca3e">获取会议室列表
<a id=获取会议室列表6348> </a></a></li><li><a href="#u83b7u53d6u4f1au8baeu5ba4u767bu5f55u5730u57400a3ca20id3du83b7u53d6u4f1au8baeu5ba4u767bu5f55u5730u574063483e203ca3e">获取会议室登录地址
<a id=获取会议室登录地址6348> </a></a></li><li><a href="#u6309u7167u4f1au8baeu65f6u95f4u67e5u8be2u4f1au8baeu8be6u60c50a3ca20id3du6309u7167u4f1au8baeu65f6u95f4u67e5u8be2u4f1au8baeu8be6u60c563483e203ca3e">按照会议时间查询会议详情
<a id=按照会议时间查询会议详情6348> </a></a></li><li><a href="#u67e5u8be2u4f01u4e1au7684u5f53u524du4f1au8baeuff08u5f53u524du5728u7ebfu7684u4f1au8baeu5ba4uff090a3ca20id3du67e5u8be2u4f01u4e1au7684u5f53u524du4f1au8baeuff08u5f53u524du5728u7ebfu7684u4f1au8baeu5ba4uff0963483e203ca3e">查询企业的当前会议（当前在线的会议室）
<a id=查询企业的当前会议（当前在线的会议室）6348> </a></a></li><li><a href="#u67e5u8be2u4f1au8baeu5ba4u53c2u4f1au4ebau4fe1u606f0a3ca20id3du67e5u8be2u4f1au8baeu5ba4u53c2u4f1au4ebau4fe1u606f63483e203ca3e">查询会议室参会人信息
<a id=查询会议室参会人信息6348> </a></a></li><li><a href="#u83b7u53d6u4f1au8baeu5ba4u5f53u524du4ebau65700a3ca20id3du83b7u53d6u4f1au8baeu5ba4u5f53u524du4ebau657063483e203ca3e">获取会议室当前人数
<a id=获取会议室当前人数6348> </a></a></li><li><a href="#u83b7u53d6u67d0u4e2au7528u6237u662fu5426u5728u4f1au8baeu4e2d0a3ca20id3du83b7u53d6u67d0u4e2au7528u6237u662fu5426u5728u4f1au8baeu4e2d63483e203ca3e">获取某个用户是否在会议中
<a id=获取某个用户是否在会议中6348> </a></a></li><li><a href="#u83b7u53d6u7528u6237u6709u6743u9650u7684u4f1au8baeu5ba4u5217u88680a3ca20id3du83b7u53d6u7528u6237u6709u6743u9650u7684u4f1au8baeu5ba4u5217u886863483e203ca3e">获取用户有权限的会议室列表
<a id=获取用户有权限的会议室列表6348> </a></a></li><li><a href="#u83b7u53d6u4f1au8baeu5f53u524du7528u6237u5217u88680a3ca20id3du83b7u53d6u4f1au8baeu5f53u524du7528u6237u5217u886863483e203ca3e">获取会议当前用户列表
<a id=获取会议当前用户列表6348> </a></a></li><li><a href="#u83b7u53d6u6307u5b9au4f1au8baeu5ba4u6388u6743u7684u7528u6237u5217u88680a3ca20id3du83b7u53d6u6307u5b9au4f1au8baeu5ba4u6388u6743u7684u7528u6237u5217u886863483e203ca3e">获取指定会议室授权的用户列表
<a id=获取指定会议室授权的用户列表6348> </a></a></li><li><a href="#u53d1u9001u6587u5b57u5230u6307u5b9au4f1au8baeu5ba4u7684u7528u62370a3ca20id3du53d1u9001u6587u5b57u5230u6307u5b9au4f1au8baeu5ba4u7684u7528u623763483e203ca3e">发送文字到指定会议室的用户
<a id=发送文字到指定会议室的用户6348> </a></a></li></ul></li><li><a href="#u4f1au63a7u63a5u53e3">会控接口</a><ul><li><a href="#u4f1au4e2du63a7u52360a3ca20id3du4f1au4e2du63a7u523663553e203ca3e">会中控制
<a id=会中控制6355> </a></a></li><li><a href="#u8ba2u9605u5220u96640a3ca20id3du8ba2u9605u5220u966463553e203ca3e">订阅删除
<a id=订阅删除6355> </a></a></li><li><a href="#u8ba2u9605u65b0u589e0a3ca20id3du8ba2u9605u65b0u589e63553e203ca3e">订阅新增
<a id=订阅新增6355> </a></a></li><li><a href="#u8ba2u9605u67e5u8be20a3ca20id3du8ba2u9605u67e5u8be263553e203ca3e">订阅查询
<a id=订阅查询6355> </a></a></li></ul></li></ul></div>
          <div id="right" class="content-right">
           <h1 class="curproject-name"> 私有云 4.39.4 接口文档</h1> 

<h1 id="u9274u6743u76f8u5173u8bf4u660e">鉴权相关说明</h1>
<p></p>
<h2 id="u751fu6210token0a3ca20id3du751fu6210token63203e203ca3e">生成Token
<a id=生成Token6320> </a></h2>
<p></p>
<h3 id="">基本信息</h3>
<p><strong>Path：</strong> /main</p>
<p><strong>Method：</strong> HEAD</p>
<p><strong>接口描述：</strong></p>
<h3>1. 说明信息</h3>
<blockquote>
<p>在调用API接口时，需要提前申请一对 Key及Secret，并在每一个接口调用时带上一个生成的JWT Token值，用于接口的签名/认证。</p>
<p>请妥善保管好key以及secret，如有泄露，及时反馈申请新的密钥。</p>
</blockquote>
<p><span class="colour" style="color:rgb(51, 51, 51)">JWT由三部分构成：Header, Payload, Signature，每一部分用符号点（.）分隔，如下所示：</span></p>
<p><span class="colour" style="color:rgb(51, 51, 51)">aaaa.bbbb.cccc</span></p>
<p><span class="colour" style="color:rgb(51, 51, 51)">三部分定义如下：</span></p>
<pre><code>1) Header：
    {
     "alg": "算法"  // 使用SHA256或者SM3算法
    }
2) Payload:
  {
 &nbsp; &nbsp;"key": "账号名", // 提供的账号名称
 &nbsp; &nbsp;"timestamp ": 1633677195085 // long类型，值为系统当前时间戳，单位为毫秒，用于检查token的过期时间
  }

<li>3.Signature：<br>
HMACSHA256(<br>
&nbsp; &nbsp;base64UrlEncode(header) + &quot;.&quot; 
&nbsp; &nbsp;base64UrlEncode(payload),
&nbsp; &nbsp;Secret)<br></li>

</code></pre>

<h3>2. 加密方式</h3>
<p><span class="colour" style="color:rgb(51, 51, 51)">出于安全的考虑，对传输中的敏感信息进行加密，使用的算法为SHA256,具体生成 JWT Token 步骤如下： 执行main函数，生成token</span></p>
<pre><code>public static void main(String[] aaa) { 
 &nbsp; long timestamp = System.currentTimeMillis();
<p> String secret = &quot;密钥&quot;;</p>
<p> String header = Base64.getEncoder().encodeToString(&quot;{&quot;alg&quot;: &quot;算法&quot;}&quot;.getBytes(StandardCharsets.UTF_8));<br></p>
<p>String load = Base64.getEncoder().encodeToString((&quot;{ &quot;key&quot;: &quot;账号&quot;, &quot;timestamp&quot;: &quot; + timestamp + &quot;}&quot;)<br></p>
<p>     .getBytes(StandardCharsets.UTF_8));</p>
<p>// SHA256算法加密</p>
<p> String signature = SHAUtil.SHA256(header + load + secret);</p>
<p>// SM3算法加密<br>
//String signature = SM3.encrypt(header + load + secret);</p>
<p> System.out.println(header + &quot;.&quot; + load + &quot;.&quot; + signature);<br></p>
}<br>
</code></pre>
<p><br data-tomark-pass=""><br>
<br data-tomark-pass=""></p>
<h5><span class="colour" style="color:rgb(51, 51, 51)">调用所需的SHA256算法工具类：</span></h5>
<pre><code>public class SHAUtil {
    /**
 &nbsp; &nbsp; * SHA256
 &nbsp; &nbsp; */
 &nbsp; &nbsp;public static String SHA256(String str) {
 &nbsp; &nbsp; &nbsp; &nbsp;MessageDigest messageDigest;
 &nbsp; &nbsp; &nbsp; &nbsp;String encodeStr = "";
 &nbsp; &nbsp; &nbsp; &nbsp;try {
 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;messageDigest = MessageDigest.getInstance("SHA-256");
 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;messageDigest.update(str.getBytes(StandardCharsets.UTF_8));
 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;encodeStr = byte2Hex(messageDigest.digest());
 &nbsp; &nbsp; &nbsp;  } catch (NoSuchAlgorithmException ex) {
 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ex.printStackTrace();
 &nbsp; &nbsp; &nbsp;  }
 &nbsp; &nbsp; &nbsp; &nbsp;return encodeStr;
 &nbsp;  }
<p> 
&nbsp; &nbsp;/**<br>
&nbsp; &nbsp; * 将byte转为16进制<br>
&nbsp; &nbsp; * @param bytes<br>
&nbsp; &nbsp; * @return<br>
&nbsp; &nbsp; */
<p> private static String byte2Hex(byte[] bytes) {
<p>  StringBuilder sb = new StringBuilder();
<p>   String temp;
<p>   for (byte aByte : bytes) {
<p>     temp = Integer.toHexString(aByte &amp; 0xFF);
<p>     if (temp.length() == 1) {
<p>       // 1得到一位的进行补0操作
<p>       sb.append(&quot;0&quot;);
<p>      }
<p>     sb.append(temp);
<p>    }
<p>   return sb.toString();
<p> }<br>
<p> /**
&nbsp;&nbsp;  * HMACSHA256 加密算法<br>
&nbsp;&nbsp;  * @param data 加密字符串<br>
&nbsp;&nbsp;  * @param key 密钥<br>
&nbsp;&nbsp;  * @return 加密结果字符串<br>
&nbsp;&nbsp;  */<br>
<p> public static String HMACSHA256(String data, String key){
<p>  StringBuilder sb = new StringBuilder();
<p>   try {<br>
<p>  Mac sha256_HMAC = Mac.getInstance(&quot;HmacSHA256&quot;);
<p>     SecretKeySpec secret_key = new SecretKeySpec(key.getBytes(&quot;UTF-8&quot;), &quot;HmacSHA256&quot;);
<p>     sha256_HMAC.init(secret_key);
<p>     byte[] array = sha256_HMAC.doFinal(data.getBytes(&quot;UTF-8&quot;));
<p>     for (byte item : array) {
<p>       sb.append(Integer.toHexString((item &amp; 0xFF) | 0x100).substring(1, 3));
<p>      } 
<p>    } catch (Exception ex) {
<p>    ex.printStackTrace();
<p>    } 
<p>  return sb.toString(); 
<p> } </p>
}<br>
</code></pre><br data-tomark-pass=""><br>
<br data-tomark-pass="">

<h5>调用所需的SM3加密算法工具类：</h5>
<pre><code>
<p>public class SM3 { </p>
<p>static {

    Security.addProvider(new BouncyCastleProvider());
<p>}</p>
/**

 * SM3加密

 * @param paramStr 待加密字符串

 * @return 返回加密后，固定长度=64的16进制字符串

 */

public static String encrypt(String paramStr) {

    //将字符串转换成byte数组

    byte[] srcData = paramStr.getBytes(StandardCharsets.UTF_8);
    <p>byte[] resultHash = hash(srcData);</p>
    //将返回的hash值转换成16进制字符串

    return ByteUtils.toHexString(resultHash);    }


/**

 * 返回长度为32的byte数组

 * 生成对应的hash值

 */

public static byte[] hash(byte[] srcData) {

    SM3Digest digest = new SM3Digest();        digest.update(srcData, 0, srcData.length);

    byte[] hash = new byte[digest.getDigestSize()];

    digest.doFinal(hash, 0);

    return hash;

}


/**

 * 通过指定密钥进行加密

 * @param key     密钥

 * @param srcData 被加密的byte数组

 */

public static byte[] hmac(byte[] key, byte[] srcData) {

    KeyParameter keyParameter = new KeyParameter(key);

        
    SM3Digest digest = new SM3Digest();
    HMac mac = new HMac(digest);

    mac.init(keyParameter);

    mac.update(srcData, 0, srcData.length);

    byte[] result = new byte[mac.getMacSize()];

    mac.doFinal(result, 0);

    return result;

}


/**

 * 判断数据源与加密数据是否一致，通过验证原数组和生成是hash数组是否为同一数组，验证二者是否为同一数据

 */

public static boolean verify(String srcStr, String sm3HexString) {

    byte[] srcData = srcStr.getBytes(StandardCharsets.UTF_8);

  byte[] sm3Hash = ByteUtils.fromHexString(sm3HexString);
  byte[] newHash = hash(srcData);

<p> return Arrays.equals(newHash, sm3Hash);

<p> } </p>

</code></pre>
<h3>3.请求头</h3>
<p><span class="colour" style="color:rgb(51, 51, 51)">由于拦截器对所有api接口路径进行拦截，要求在进行接口调用时携带请求头参数以便认证。</span></p>
<pre><code>参数说明：
 键：Authorization
 值：main函数生成打印的token信息
<p>Postman请求示例：<br>
Header<br>
<p></p>键:Authorization值:eyJhbGciOiAiU0hBMjU2In0=.eyAia2V5IjogIjRRWTA4S3kiLCAidGltZXN0YW1wIjogMTYzMzY4MDI1NTA1N30=.a91d913f60f51fa37f4ce5f9242f37d616a768f7a4befa7cfb66266e2df1e99a<br>
</code></pre></p>
<table>
<thead>
<tr>
<th>键</th>
<th>值（鉴权生成的token值）</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>Authorization</td>
<td>eyJhbGciOiAiU0hBMjU2In0=.eyAia2V5IjogIjRRWTA4S3loIiwg<br>InRpbWVzdGFtcCI6IDE2MzM3NDc2Mjg1Njl9.2bac10ce0cea85<br>d70f962c0cfc9fff876658e23ed7459cf3d5560859a630746e</td>
<td>开发者手动生成得到的token值，有效期为十分钟</td>
</tr>
</tbody>
</table>
<p><strong>注意：</strong><br>
文档并不存在/main接口，需要开发者仔细阅读文档后，新建main函数和工具类，替换对应key（账户名）、secret(密钥)和算法(SHA256、SM3)的值，即可生成3.请求头中所需要的值，该值有效时间为十分钟。</p>

<table>
  <thead class="ant-table-thead">
    <tr>
      
    </tr>
  </thead><tbody className="ant-table-tbody">
               </tbody>
              </table>
<h2 id="u9274u6743u76f8u5173u9519u8befu78010a3ca20id3du9274u6743u76f8u5173u9519u8befu780163203e203ca3e">鉴权相关错误码
<a id=鉴权相关错误码6320> </a></h2>
<p></p>
<h3 id="-4">基本信息</h3>
<p><strong>Path：</strong> /code</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<table>
<thead>
<tr>
<th>错误码</th>
<th>错误信息</th>
<th>参考值</th>
</tr>
</thead>
<tbody>
<tr>
<td>1001</td>
<td>非法请求头</td>
<td>键：Authorization</td>
</tr>
<tr>
<td>1002</td>
<td>非法请求值</td>
<td>值：eyJhbGciOiAiU0hBMjU2In0=.eyAia2V5IjogIjRRWTA4S3loIiwgInRpbWVzdGFtcCI6IDE2Mz<br>M3NjA0NzI0NDl9.863d1f9f95704de6dd95de9a55f9ef747639fcf3bdd0715e4d51a41a34fdce28</td>
</tr>
<tr>
<td>1003</td>
<td>无效认证信息</td>
<td><span class="colour" style="color: rgb(85, 85, 85);">token过期（有效期十分钟）或key（账户名）错误</span></td>
</tr>
<tr>
<td>1004</td>
<td>签名算法不支持</td>
<td>仅支持SHA256、SM3</td>
</tr>
<tr>
<td>1005</td>
<td>签名错误</td>
<td>请求头中的值与生成的token不一致</td>
</tr>
</tbody>
</table>
<p><strong>注意：</strong><br>
不存在/code接口路径，仅提供错误码介绍信息。</p>


<h1 id="u9519u8befu8fd4u56deu7801">错误返回码</h1>
<p></p>
<h2 id="u8fd4u56deu78010a3ca20id3du8fd4u56deu780163273e203ca3e">返回码
<a id=返回码6327> </a></h2>
<p></p>
<h3 id="-7">基本信息</h3>
<p><strong>Path：</strong> /code</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<table>
<thead>
<tr>
<th>返回码</th>
<th>描述</th>
<th>修订人</th>
</tr>
</thead>
<tbody>
<tr>
<td></td>
<td>系统总体返回码</td>
<td></td>
</tr>
<tr>
<td>0000</td>
<td>操作成功</td>
<td></td>
</tr>
<tr>
<td>9003</td>
<td>数据校验异常</td>
<td></td>
</tr>
<tr>
<td>9002</td>
<td>业务异常</td>
<td></td>
</tr>
<tr>
<td>9999</td>
<td>系统错误</td>
<td></td>
</tr>
<tr>
<td></td>
<td>公共错误返回码</td>
<td></td>
</tr>
<tr>
<td>0001</td>
<td>ID和名称不能同时为空</td>
<td></td>
</tr>
<tr>
<td>0002</td>
<td>数据信息不存在或用户操作失误</td>
<td></td>
</tr>
<tr>
<td>0003</td>
<td>密钥错误</td>
<td></td>
</tr>
<tr>
<td>0004</td>
<td>密码不是MD5字符串</td>
<td></td>
</tr>
<tr>
<td></td>
<td>用户模块返回码</td>
<td></td>
</tr>
<tr>
<td>1001</td>
<td>用户名已存在或用户参数错误</td>
<td></td>
</tr>
<tr>
<td>1002</td>
<td>用户名格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>1003</td>
<td>密码格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>1004</td>
<td>昵称不为空时格式不正确，包括长度</td>
<td></td>
</tr>
<tr>
<td>1005</td>
<td>组织不为空时格式不正确，包括长度，整数</td>
<td></td>
</tr>
<tr>
<td>1006</td>
<td>角色不为空时格式不正确，包括长度，整数</td>
<td></td>
</tr>
<tr>
<td>1007</td>
<td>性别不为空时格式不正确，包括长度，整数</td>
<td></td>
</tr>
<tr>
<td>1008</td>
<td>电话号码格式非法</td>
<td></td>
</tr>
<tr>
<td>1009</td>
<td>手机号码格式非法</td>
<td></td>
</tr>
<tr>
<td>1010</td>
<td>邮箱格式非法</td>
<td></td>
</tr>
<tr>
<td>1011</td>
<td>用户数量错误</td>
<td></td>
</tr>
<tr>
<td>1012</td>
<td>用户不存在</td>
<td></td>
</tr>
<tr>
<td>1013</td>
<td>组织不存在</td>
<td></td>
</tr>
<tr>
<td>1014</td>
<td>角色不存在</td>
<td></td>
</tr>
<tr>
<td>1015</td>
<td>用户删除错误</td>
<td></td>
</tr>
<tr>
<td>1016</td>
<td>查询类型错误或为空</td>
<td></td>
</tr>
<tr>
<td>1017</td>
<td>用户查询分页超过最大允许条数</td>
<td></td>
</tr>
<tr>
<td>1018</td>
<td>用户查询时，房间ID参数为空</td>
<td></td>
</tr>
<tr>
<td>1019</td>
<td>授权会议室名单字符串为空</td>
<td></td>
</tr>
<tr>
<td>1020</td>
<td>授权会议室名单字符串格式错误或为空</td>
<td></td>
</tr>
<tr>
<td>1021</td>
<td>会议室不存在</td>
<td></td>
</tr>
<tr>
<td>1022</td>
<td>会议室删除错误</td>
<td></td>
</tr>
<tr>
<td>1023</td>
<td>会议室密码类型错误</td>
<td></td>
</tr>
<tr>
<td>1024</td>
<td>用户保存错误</td>
<td></td>
</tr>
<tr>
<td>1025</td>
<td>用户属性类型只能为1或者2</td>
<td></td>
</tr>
<tr>
<td>1026</td>
<td>不能对系统用户进行操作</td>
<td></td>
</tr>
<tr>
<td></td>
<td>会议室模块返回码</td>
<td></td>
</tr>
<tr>
<td>2000</td>
<td>会议ID格式错误或为空，包括长度应在3-11之间</td>
<td></td>
</tr>
<tr>
<td>2001</td>
<td>会议室名称为空或长度错误</td>
<td></td>
</tr>
<tr>
<td>2002</td>
<td>会议室登录校验模型类型不存在</td>
<td></td>
</tr>
<tr>
<td>2003</td>
<td>会议室最大数量错误或为空</td>
<td></td>
</tr>
<tr>
<td>2004</td>
<td>是否启用主席密码类型值错误</td>
<td></td>
</tr>
<tr>
<td>2005</td>
<td>主席密码格式错误或为空</td>
<td></td>
</tr>
<tr>
<td>2006</td>
<td>房间信息保存错误</td>
<td></td>
</tr>
<tr>
<td>2007</td>
<td>房间类型修改错误</td>
<td></td>
</tr>
<tr>
<td>2008</td>
<td>日期格式错误</td>
<td></td>
</tr>
<tr>
<td>2009</td>
<td>日期逻辑非法（开始时间晚于结束时间，开始时间早于当前时间）</td>
<td></td>
</tr>
<tr>
<td>2010</td>
<td>时间格式错误</td>
<td></td>
</tr>
<tr>
<td>2011</td>
<td>时间逻辑非法（开始时间晚于结束时间）</td>
<td></td>
</tr>
<tr>
<td>2012</td>
<td>周例会循环模式类型值错误</td>
<td></td>
</tr>
<tr>
<td>2013</td>
<td>周例会为每周时，周字符串错误或为空</td>
<td></td>
</tr>
<tr>
<td>2014</td>
<td>周例会为每月时，天字符串错误或为空</td>
<td></td>
</tr>
<tr>
<td>2015</td>
<td>是否启用默认配置值错误或为空</td>
<td></td>
</tr>
<tr>
<td>2016</td>
<td>视频编码器值错误或为空</td>
<td></td>
</tr>
<tr>
<td>2017</td>
<td>视频码流数值错误或为空</td>
<td></td>
</tr>
<tr>
<td>2018</td>
<td>默认视频分辨率值错误或为空，或无权限（4K）</td>
<td></td>
</tr>
<tr>
<td>2019</td>
<td>授权者用户名单格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>2020</td>
<td>会议室状态值非法（不是0或1）或为空</td>
<td></td>
</tr>
<tr>
<td>2021</td>
<td>会议室名称格式错误</td>
<td></td>
</tr>
<tr>
<td>2022</td>
<td>会议室密码规则错误</td>
<td></td>
</tr>
<tr>
<td>2023</td>
<td>会议室布局格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>2024</td>
<td>会议室模式格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>2025</td>
<td>会议室权限格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>2026</td>
<td>录制任务ID不能为空</td>
<td></td>
</tr>
<tr>
<td>2027</td>
<td>时间间隔不能超过30天</td>
<td></td>
</tr>
<tr>
<td>2028</td>
<td>会议室全局配置不能修改</td>
<td></td>
</tr>
<tr>
<td></td>
<td>组织架构返回码</td>
<td></td>
</tr>
<tr>
<td>3001</td>
<td>组织架构名称格式错误或为空，包括长度</td>
<td></td>
</tr>
<tr>
<td>3002</td>
<td>顶级组织不唯一</td>
<td></td>
</tr>
<tr>
<td>3003</td>
<td>上级组织架构ID不能为当前组织的子级</td>
<td></td>
</tr>
<tr>
<td>3004</td>
<td>上级组织架构ID不存在</td>
<td></td>
</tr>
<tr>
<td>3005</td>
<td>上级组织架构ID格式错误或为空，包括长度，整数</td>
<td></td>
</tr>
<tr>
<td>3006</td>
<td>组织结构ID不存在</td>
<td></td>
</tr>
<tr>
<td></td>
<td>会议控制返回码</td>
<td></td>
</tr>
<tr>
<td>4001</td>
<td>应用返回提示不能为空，或长度不能超过64</td>
<td></td>
</tr>
<tr>
<td>4003</td>
<td>服务器消息处理超时</td>
<td></td>
</tr>
<tr>
<td>4009</td>
<td>用户属性值长度不能超过64*1000</td>
<td></td>
</tr>
<tr>
<td>4010</td>
<td>用户属性值不能为空</td>
<td></td>
</tr>
<tr>
<td>4011</td>
<td>无法连接到服务器</td>
<td></td>
</tr>
<tr>
<td>4012</td>
<td>操作者长度不能超过64</td>
<td></td>
</tr>
<tr>
<td>4013</td>
<td>批量新增会议室错误</td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>注意：</strong><br>
<span class="colour" style="color:rgb(85, 85, 85)">不存在/code接口路径，仅提供返回码描述信息。</span></p>

<h1 id="u90e8u95e8u76f8u5173u63a5u53e3">部门相关接口</h1>
<p></p>
<h2 id="u4feeu6539u7ec4u7ec7u67b6u67840a3ca20id3du4feeu6539u7ec4u7ec7u67b6u678463343e203ca3e">修改组织架构
<a id=修改组织架构6334> </a></h2>
<p></p>
<h3 id="-9">基本信息</h3>
<p><strong>Path：</strong> /api/v1/department/edit</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-10">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织机构ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构名称: 支持数字、字母、下划线，长度在1-32位之间</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> parentDepartId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">上级组织架构ID: 上级组织架构为顶级则设置0</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-11">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u5206u9875u67e5u8be2u7ec4u7ec7u67b6u67840a3ca20id3du5206u9875u67e5u8be2u7ec4u7ec7u67b6u678463343e203ca3e">分页查询组织架构
<a id=分页查询组织架构6334> </a></h2>
<p></p>
<h3 id="-12">基本信息</h3>
<p><strong>Path：</strong> /api/v1/department/list</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<p>当根据departId精确查询，或根据departName模糊查询时，需要保证会议室中该条数据的NodeId字段存在有效值，否则将无法查询到有效信息。</p>
<h3 id="-13">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td>{<br/>}</td>
<td>以Postman为例，不传参时也需要在Boby中以raw-json的形式传一个空的json串</td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织机构ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构名称</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门编码</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-14">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">PageVO«DepartinfoBean»</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">当前页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总页数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">查询数据列表</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-2-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> backUpDepartId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">备份部门编号</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departDesc</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门描述，128个字符</span></td><td key=5></td></tr><tr key=0-1-2-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门编号，长度11，int类型</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-3><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departLevel</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门级别</span></td><td key=5></td></tr><tr key=0-1-2-4><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门名称</span></td><td key=5></td></tr><tr key=0-1-2-5><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门类型</span></td><td key=5></td></tr><tr key=0-1-2-6><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> isFinalDepart</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否最后节点</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-7><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> nodeId</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">节点编号</span></td><td key=5></td></tr><tr key=0-1-2-8><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> parentDepartId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">父部门编号</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-9><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> code</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">编码</span></td><td key=5></td></tr><tr key=0-1-2-10><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> parentCode</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">父部门编码</span></td><td key=5></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示条数，默认 5</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u521bu5efau7ec4u7ec7u67b6u67840a3ca20id3du521bu5efau7ec4u7ec7u67b6u678463343e203ca3e">创建组织架构
<a id=创建组织架构6334> </a></h2>
<p></p>
<h3 id="-15">基本信息</h3>
<p><strong>Path：</strong> /api/v1/department/add</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-16">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td>{<br/>}</td>
<td>以Postman为例，不传参时也需要在Boby中以raw-json的形式传一个空的json串</td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构名称: 支持数字、字母、下划线，长度在1-32位之间</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> parentDepartId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">上级组织架构ID: 上级组织架构为顶级则设置0，注意:顶级组织只能存在一个</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-17">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门组织id</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u5220u9664u7ec4u7ec7u67b6u67840a3ca20id3du5220u9664u7ec4u7ec7u67b6u678463343e203ca3e">删除组织架构
<a id=删除组织架构6334> </a></h2>
<p></p>
<h3 id="-18">基本信息</h3>
<p><strong>Path：</strong> /api/v1/department/delete</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-19">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织机构ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-20">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h1 id="u7528u6237u76f8u5173u63a5u53e3">用户相关接口</h1>
<p></p>
<h2 id="u4feeu6539u7528u6237u4fe1u606f0a3ca20id3du4feeu6539u7528u6237u4fe1u606f63413e203ca3e">修改用户信息
<a id=修改用户信息6341> </a></h2>
<p></p>
<h3 id="-21">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/edit</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-22">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> adminRole</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">角色 基本角色值为2,默认为基本角色</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名支持汉字、英文字母a-zA-Z、数字0-9、英文下划线,长度在1-32位之间</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构 组织架构为0时，查询出根组织在根组织上创建用户，如不指定组织，填0即可</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> mobile</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">手机号码</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> nickName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">昵称</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">密码长度必须位于8-32之间，支持全角字符，数字、字母、特殊符号；由数字、字母等混合组成。</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> passwordType</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">密码类型（是否MD5加密）默认为0，为0时传入普通密码，为1时传入MD5加密后的密码。</span></td><td key=5><p key=0><span style="font-weight: '700'">最大值: </span><span>1</span></p><p key=1><span style="font-weight: '700'">最小值: </span><span>0</span></p></td></tr><tr key=0-7><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> sex</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">性别 默认为男性，值为0；女性为1</span></td><td key=5></td></tr><tr key=0-8><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> telePhone</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">固定电话6-32位数字</span></td><td key=5></td></tr><tr key=0-9><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> email</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">电子邮箱</span></td><td key=5></td></tr><tr key=0-10><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> privateData</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">客户端拉流地址，发送内容示例：{"stream":{"name":"海康威视Rtsp摄像头1","addr":"rtsp://admin:password@192.168.1.64:554/Streaming/Channels/101"}} ， 注意：如果不修改，则传参不用添加privateData参数</span></td><td key=5></td></tr><tr key=0-11><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> publicData</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户类型: [1:专家 2:监管 3: 评标室管理员 4: 投标人]，发送内容示例：{"userType":1} ，注意：如果不修改，则传参不用添加publicData参数</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-23">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> displayName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> sex</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> mobile</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> telePhone</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> email</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userLevel</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> adminRole</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u5220u9664u7528u6237u4fe1u606f0a3ca20id3du5220u9664u7528u6237u4fe1u606f63413e203ca3e">删除用户信息
<a id=删除用户信息6341> </a></h2>
<p></p>
<h3 id="-24">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/del</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-25">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-26">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u6279u91cfu6ce8u518cu7528u62370a3ca20id3du6279u91cfu6ce8u518cu7528u623763413e203ca3e">批量注册用户
<a id=批量注册用户6341> </a></h2>
<p></p>
<h3 id="-27">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/addBatch</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<p>此接口为批量添加用户，根据用户前缀生成，例：abc00 - abc99 ,最多同时添加100个， 如用户名存在，则忽略跳过，返回成功添加的用户集合。</p>
<h3 id="-28">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名前缀，用户名支持汉字、英文字母a-zA-Z、数字0-9、英文下划线,长度在1-32位之间</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> password</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">密码长度必须位于8-32之间，支持全角字符，数字、字母、特殊符号；由数字、字母等混合组成。</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> passwordType</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">密码类型（是否MD5加密）默认为0，为0时传入普通密码，为1时传入MD5加密后的密码。</span></td><td key=5><p key=0><span style="font-weight: '700'">最大值: </span><span>1</span></p><p key=1><span style="font-weight: '700'">最小值: </span><span>0</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> number</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户数量，取值范围 1 - 100 。10代表批量添加 用户名00 - 用户名09</span></td><td key=5><p key=0><span style="font-weight: '700'">最大值: </span><span>100</span></p><p key=1><span style="font-weight: '700'">最小值: </span><span>1</span></p><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构ID ,组织架构为0时，查询出根组织在根组织上创建用户，如不指定组织，填0即可。默认为1</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> adminRole</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">角色 基本角色值为2,默认为基本角色</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> publicData</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户类型: [1:专家 2:监管 3: 评标室管理员 4: 投标人]，发送内容示例：{"userType":1} , 注意：如果不传，后台则默认按照1(专家)处理</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-29">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> displayName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> sex</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> mobile</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> telePhone</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> email</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userLevel</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> adminRole</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u65b0u589eu7528u6237u4fe1u606f0a3ca20id3du65b0u589eu7528u6237u4fe1u606f63413e203ca3e">新增用户信息
<a id=新增用户信息6341> </a></h2>
<p></p>
<h3 id="-30">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/add</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-31">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名称，支持汉字、英文字母a-zA-Z、数字0-9、英文下划线,长度在1-32位之间</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> password</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">密码长度必须位于8-32之间，支持全角字符，数字、字母、特殊符号；由数字、字母等混合组成。</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> passwordType</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">密码类型（是否MD5加密）默认为0，为0时传入普通密码，为1时传入MD5加密后的密码。</span></td><td key=5><p key=0><span style="font-weight: '700'">最大值: </span><span>1</span></p><p key=1><span style="font-weight: '700'">最小值: </span><span>0</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> email</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">电子邮箱</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> mobile</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">手机号码</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> nickName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">昵称，不填默认为用户名</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> sex</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">性别 默认为男性，值为0；女性为1</span></td><td key=5></td></tr><tr key=0-7><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> telePhone</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">固定电话6-32位数字</span></td><td key=5></td></tr><tr key=0-8><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构ID，组织架构为0时，查询出根组织在根组织上创建用户，如不指定组织，填0即可。不填默认为1</span></td><td key=5></td></tr><tr key=0-9><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> adminRole</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">角色 基本角色值为2,默认为基本角色</span></td><td key=5></td></tr><tr key=0-10><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> privateData</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">客户端拉流地址，发送内容示例：{"stream":{"name":"海康威视Rtsp摄像头1","addr":"rtsp://admin:password@192.168.1.64:554/Streaming/Channels/101"}}</span></td><td key=5></td></tr><tr key=0-11><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> publicData</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户类型: [1:专家 2:监管 3: 评标室管理员 4: 投标人]，发送内容示例：{"userType":1} , 注意：如果不传，后台则默认按照1(专家)处理</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-32">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> displayName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> sex</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> mobile</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> telePhone</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> email</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userLevel</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> adminRole</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u67e5u8be2u7528u6237u4fe1u606f0a3ca20id3du67e5u8be2u7528u6237u4fe1u606f63413e203ca3e">查询用户信息
<a id=查询用户信息6341> </a></h2>
<p></p>
<h3 id="-33">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/list</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-34">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> searchKey</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名搜索，即返回除了admin、recordclient系统默认用户的所有用户</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> searchType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">搜索类型 类型值0为前后模糊搜索，1全匹配</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织架构ID,获取该组织下的用户列表</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-35">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-2-0-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-3><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> displayName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-4><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> sex</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-5><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-6><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> mobile</span></td><td key=1><span>string,null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-7><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> telePhone</span></td><td key=1><span>string,null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-8><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> email</span></td><td key=1><span>string,null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-9><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userLevel</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-10><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-11><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>number</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-12><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> adminRole</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u7528u6237u5728u7ebfu60c5u51b50a3ca20id3du83b7u53d6u7528u6237u5728u7ebfu60c5u51b563413e203ca3e">获取用户在线情况
<a id=获取用户在线情况6341> </a></h2>
<p></p>
<h3 id="-36">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/online/{userName}</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-37">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>userName</td>
<td></td>
<td>userName</td>
</tr>
</tbody>
</table>
<h3 id="-38">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> online</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">Byte</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> role</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> seatList</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userNodeId</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">Byte</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h1 id="u4f1au8baeu76f8u5173u63a5u53e3">会议相关接口</h1>
<p></p>
<h2 id="u4e0bu8f7du4f1au8baeu7eaau89810a3ca20id3du4e0bu8f7du4f1au8baeu7eaau898163483e203ca3e">下载会议纪要
<a id=下载会议纪要6348> </a></h2>
<p></p>
<h3 id="-39">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/summary/{groupId}</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-40">请求参数</h3>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>groupId</td>
<td></td>
<td>纪要ID</td>
</tr>
</tbody>
</table>
<h3 id="-41">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody">
               </tbody>
              </table>
<h2 id="u83b7u53d6u4f1au63a7u5730u57400a3ca20id3du83b7u53d6u4f1au63a7u5730u574063483e203ca3e">获取会控地址
<a id=获取会控地址6348> </a></h2>
<p></p>
<h3 id="-42">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/{roomId}/web-control</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-43">请求参数</h3>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomId</td>
<td></td>
<td>会议ID</td>
</tr>
</tbody>
</table>
<p><strong>Query</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>是</td>
<td></td>
<td>用户ID</td>
</tr>
</tbody>
</table>
<h3 id="-44">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> dara</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会控地址</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u4f1au8baeu7eaau89810a3ca20id3du83b7u53d6u4f1au8baeu7eaau898163483e203ca3e">获取会议纪要
<a id=获取会议纪要6348> </a></h2>
<p></p>
<h3 id="-45">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/summary</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-46">请求参数</h3>
<p><strong>Query</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomId</td>
<td>否</td>
<td></td>
<td>会议室ID</td>
</tr>
<tr>
<td>beginTime</td>
<td>是</td>
<td></td>
<td>开始时间, yyyy-MM-dd HH:mm:ss</td>
</tr>
<tr>
<td>endTime</td>
<td>是</td>
<td></td>
<td>结束时间, yyyy-MM-dd HH:mm:ss ]</td>
</tr>
<tr>
<td>pageNumber</td>
<td>否</td>
<td></td>
<td>页码, 默认1</td>
</tr>
<tr>
<td>pageSize</td>
<td>否</td>
<td></td>
<td>每页条数, 默认10</td>
</tr>
</tbody>
</table>
<h3 id="-47">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-2-0-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> name</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">名称</span></td><td key=5></td></tr><tr key=0-2-0-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> groupId</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">下载ID</span></td><td key=5></td></tr><tr key=0-2-0-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> createTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">创建时间[ yyyy-MM-dd HH:mm:ss ]</span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5f55u5236u914du7f6e0a3ca20id3du4feeu6539u4f1au8baeu5f55u5236u914du7f6e63483e203ca3e">修改会议录制配置
<a id=修改会议录制配置6348> </a></h2>
<p></p>
<h3 id="-48">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/editRoomRecordSettings</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-49">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议ID</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> standard</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制模式是标准或自定义{true:标准,false:自定义}</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> autoRecord</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动录制{false：否（默认）；true：是}</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordVideoResolution</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">视频分辨率{1:720*576 ；2:1280*720（默认）；3:1920*1080}</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制方式{录制方式：1：完整录制（默认）；2：主讲录制；3：仅录音频； 4: 指定用户；5：仅录共享内容；6：仅录主持人画面； 7：仅录共享者画面; 8: 指定用户分流录制}</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> dataDisplayMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">数据显示模式{1：平铺显示；2：等比裁剪显示；3：等比完整显示（默认）}</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> videoDisplayMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">视频显示模式{1：平铺显示；2：等比裁剪显示（默认）；3：等比完整显示}</span></td><td key=5></td></tr><tr key=0-7><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> sliceInterval</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">切片时间间隔（单位：分钟），默认60</span></td><td key=5></td></tr><tr key=0-8><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordFileSlice</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制文件是否切片{false：否；true：是（默认）}</span></td><td key=5></td></tr><tr key=0-9><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> endRecordInterval</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议持续多少时间（单位：分钟）没有接收到音视频，关闭录制，默认60</span></td><td key=5></td></tr><tr key=0-10><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> watermarkSwitch</span></td><td key=1><span>boolean []</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印开关  0、系统时间；1、文字；2、图片 （watermarkMode的翻译，对应的下标是对应的功能的开关）</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>boolean</span></p></td></tr><tr key=array-91><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">系统时间；文字；图片  三者的开关组合, 例 true,false,false, 表示仅启用系统时间，不传默认是false</span></td><td key=5></td></tr><tr key=0-11><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> watermarkText</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印文字内容</span></td><td key=5></td></tr><tr key=0-12><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> watermarkTextCss</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印文字样式, json字符串{"color":"#9aba60","opacity":29,"size":14,"location":4} Opacity表示透明度 采用0~100的整数表示，即0表示透明，100表示不透明。 location表示位置-1:左上;2:左下;3:右上(默认);4:右下。mode表示显示方式 {1、静止显示；2、随机显示；3、循环滚动}size表示文字大小 {12 -> 48}</span></td><td key=5></td></tr><tr key=0-13><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> timestampInfoLocation</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">时间戳信息位置，，3:右上(默认)，2:左下，4:右下。</span></td><td key=5></td></tr><tr key=0-14><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> watermarkPicture</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印图片（上传存储后的文件id）</span></td><td key=5></td></tr><tr key=0-15><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> watermarkPictureCss</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印图片样式, json字符串，"location":1,"mode":1,"opacity":57}  Opacity表示透明度 采用0~100的整数表示，即0表示透明，100表示不透明。location表示位置-1:左上;2:左下;3:右上(默认);4:右下。mode表示显示方式 {1、静止显示；2、随机显示；3、循环滚动}</span></td><td key=5></td></tr><tr key=0-16><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordLayoutMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制布局模式  1、默认布局  2、自定义布局  3、跟随会议</span></td><td key=5></td></tr><tr key=0-17><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordLayoutCode</span></td><td key=1><span>string []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制方案编码（recordLayoutMode = 2 时生效）</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>string</span></p></td></tr><tr key=array-92><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制方案编码</span></td><td key=5></td></tr><tr key=0-18><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordUsers</span></td><td key=1><span>integer []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">指定用户录制列表</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>integer</span></p></td></tr><tr key=array-93><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">指定用户（recordMode = 4 时生效）</span></td><td key=5></td></tr><tr key=0-19><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> autoAudit</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动审核{0：否 ；1：是}</span></td><td key=5></td></tr><tr key=0-20><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> enableExtFullRecord</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用额外的全局录制</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-50">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u521bu5efau5373u65f6u4f1au8baeu5ba40a3ca20id3du521bu5efau5373u65f6u4f1au8baeu5ba463483e203ca3e">创建即时会议室
<a id=创建即时会议室6348> </a></h2>
<p></p>
<h3 id="-51">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/createInstant</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-52">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> meetingName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名</span></td><td key=5><p key=0><span style="font-weight: '700'">最大长度: </span><span>64</span></p><p key=1><span style="font-weight: '700'">最小长度: </span><span>1</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> meetingTemplate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议模板 3：讨论</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> meetingType</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室类型 0:带有会议室的会议 1:即时会议 2:即时会议_立即开会</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> verifyMode</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">校验模型 1、用户密码验证 2、会议室密码验证 3、匿名登录</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-53">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> createTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">创建时间</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> creatorId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">创建人ID</span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> inviteCode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">邀请码</span></td><td key=5></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许最大用户数</span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingTemplate</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议模板 3：讨论</span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingType</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室类型 0:带有会议室的会议 1:即时会议 2:即时会议_立即开会</span></td><td key=5></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> nodeId</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">节点ID</span></td><td key=5></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userInfos</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-9-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> displayName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-9-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-9-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">创建人用户名</span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">校验模型 1、用户密码验证 2、会议室密码验证 3、匿名登录</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u6279u91cfu65b0u589eu4f1au8baeu5ba40a3ca20id3du6279u91cfu65b0u589eu4f1au8baeu5ba463483e203ca3e">批量新增会议室
<a id=批量新增会议室6348> </a></h2>
<p></p>
<h3 id="-54">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/batchAddRoomInfo</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-55">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> </span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> autoRecord</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动录制: 0 否 ， 1 是</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">管理员密码</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">所属组织ID</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用主席密码:0，不启用 , 1 启用</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许最大用户数</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室密码 当登录校验模型为会议室密码验证时，不允许为空。4-32位</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomMode</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室模式 : standard：标准, discussion：讨论, training：培训, custom：自定义</span></td><td key=5></td></tr><tr key=0-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名</span></td><td key=5><p key=0><span style="font-weight: '700'">最大长度: </span><span>64</span></p><p key=1><span style="font-weight: '700'">最小长度: </span><span>1</span></p></td></tr><tr key=0-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> source</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">数据来源: 0 默认，1 教育云</span></td><td key=5></td></tr><tr key=0-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">校验模型: 1、用户密码验证 2、会议室密码验证 3、匿名登录</span></td><td key=5></td></tr><tr key=0-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> menteeAdvance</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3>true</td><td key=4><span style="white-space: pre-wrap">允许所有参会人在管理员进前加入会议(false.不允许; true.允许)</span></td><td key=5></td></tr><tr key=0-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableInvite</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3>true</td><td key=4><span style="white-space: pre-wrap">是否允许邀请码登录(false.不允许; true.允许)</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-56">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> autoRecord</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> chairmanInviteCode</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> creatorId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> curUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> currentServiceId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoQos</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoQuality</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-13><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-14><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-15><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-16><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableRecord</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-17><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> endTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-18><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-19><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-20><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-21><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> menteeInviteCode</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-22><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-23><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-24><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-25><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomAppId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-26><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomDesc</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-27><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-28><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-29><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-30><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-31><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> source</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-32><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> startTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-33><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-34><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-35><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-36><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-37><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-38><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u65b0u589eu4f1au8baeu5ba40a3ca20id3du65b0u589eu4f1au8baeu5ba463483e203ca3e">新增会议室
<a id=新增会议室6348> </a></h2>
<p></p>
<h3 id="-57">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/addRoomInfo</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-58">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名</span></td><td key=5><p key=0><span style="font-weight: '700'">最大长度: </span><span>64</span></p><p key=1><span style="font-weight: '700'">最小长度: </span><span>1</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">校验模型: 1、用户密码验证 2、会议室密码验证 3、匿名登录</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许最大用户数</span></td><td key=5><p key=1><span style="font-weight: '700'">最小值: </span><span>1</span></p><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室密码 当登录校验模型为会议室密码验证时，不允许为空。4-32位</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">主席密码</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用主席密码:0，不启用 , 1 启用</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> autoRecord</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动录制: 0 否 ， 1 是</span></td><td key=5></td></tr><tr key=0-7><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室模式 : standard：标准, discussion：讨论, training：培训, custom：自定义</span></td><td key=5></td></tr><tr key=0-8><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> source</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">数据来源: 0 默认，1 教育云</span></td><td key=5></td></tr><tr key=0-9><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">所属组织ID</span></td><td key=5></td></tr><tr key=0-10><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> menteeAdvance</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3>true</td><td key=4><span style="white-space: pre-wrap">允许所有参会人在管理员进前加入会议(false.不允许; true.允许)</span></td><td key=5></td></tr><tr key=0-11><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> enableInvite</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3>true</td><td key=4><span style="white-space: pre-wrap">是否允许邀请码登录(false.不允许; true.允许)</span></td><td key=5></td></tr><tr key=0-12><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> callBitrate</span></td><td key=1><span>number</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">H323码率 [0:512、1:768、2:1024、3:1536、4:1920、5:3072 6: 8192]</span></td><td key=5></td></tr><tr key=0-13><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> meetingMinutes</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否开启会议纪要</span></td><td key=5></td></tr><tr key=0-14><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> terminalReInvite</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否终端掉线重邀</span></td><td key=5></td></tr><tr key=0-15><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> additionParam</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预留字段，发送内容示例：{"bid_num":"测试-评标会"} ， 注意：bid_num代表标段信息</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-59">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">RoominfoBean</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">主席密码</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> creatorId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">创建者id</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> curUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">当前在线用户数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> currentServiceId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">当前服务器id</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例循环模式</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">几号</span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室默认模式</span></td><td key=5></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频码流</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频编码器</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoQos</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频压缩模式</span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoQuality</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频质量</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频分辨率</span></td><td key=5></td></tr><tr key=0-1-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">所属组织ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-13><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否允许主席密码</span></td><td key=5></td></tr><tr key=0-1-14><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableRecord</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用录制</span></td><td key=5></td></tr><tr key=0-1-15><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> endTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">实际结束时间</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-16><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定结束时间</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-17><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定开始时间</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-18><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许最大用户数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-19><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室密码</span></td><td key=5></td></tr><tr key=0-1-20><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制结束时间</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-21><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制开始时间</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-22><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomAppId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室应用ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-23><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomDesc</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室描述</span></td><td key=5></td></tr><tr key=0-1-24><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-25><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名称</span></td><td key=5></td></tr><tr key=0-1-26><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室类型</span></td><td key=5></td></tr><tr key=0-1-27><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> startTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">实际开始时间</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-28><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室状态</span></td><td key=5></td></tr><tr key=0-1-29><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用默认配置</span></td><td key=5></td></tr><tr key=0-1-30><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">登录校验模型</span></td><td key=5></td></tr><tr key=0-1-31><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例会议结束时间</span></td><td key=5></td></tr><tr key=0-1-32><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例会议开始时间</span></td><td key=5></td></tr><tr key=0-1-33><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">星期几</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u67e5u8be2u4f1au8baeu5f55u5236u914du7f6e0a3ca20id3du67e5u8be2u4f1au8baeu5f55u5236u914du7f6e63483e203ca3e">查询会议录制配置
<a id=查询会议录制配置6348> </a></h2>
<p></p>
<h3 id="-60">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/queryRoomRecordSettings</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-61">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Query</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomId</td>
<td>是</td>
<td></td>
<td>会议室ID</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomid</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议ID</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> autoRecord</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">入会自动录制标识</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> videoResolution</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">视频分辨率</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> recordMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制方式</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> dataDisplayMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">视频显示模式</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> videoDisplayMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">数据显示模式</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> sliceInterval</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制文件切片</span></td><td key=5></td></tr><tr key=0-7><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> timestampInfo</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制时间展示</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-62">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室id</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> standard</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制模式是标准或自定义{true:标准,false:自定义}</span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> autoRecord</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动录制{false：否（默认）；true：是}</span></td><td key=5></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordVideoResolution</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">视频分辨率{1:720*576 ；2:1280*720；3:1920*1080}</span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制方式{录制方式：1：完整录制（默认）；2：主讲录制；3：仅录音频； 4: 指定用户；5：仅录共享内容；6：仅录主持人画面； 7：仅录共享者画面}</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dataDisplayMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">数据显示模式{1：平铺显示；2：等比裁剪显示；3：等比完整显示（默认）}</span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> videoDisplayMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">视频显示模式{1：平铺显示；2：等比裁剪显示（默认）；3：等比完整显示}</span></td><td key=5></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> sliceInterval</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">切片时间间隔（单位：分钟）</span></td><td key=5></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordFileSlice</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制文件是否切片{false：否；true：是（默认）</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> endRecordInterval</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议持续多少时间（单位：分钟）没有接收到音视频，关闭录制</span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> watermarkMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印内容{二进制位开关  1、系统时间；2、文字；3、图片}</span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> watermarkSwitch</span></td><td key=1><span>boolean []</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印开关  0、系统时间；1、文字；2、图片 （watermarkMode的翻译，对应的下标是对应的功能的开关）</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>boolean</span></p></td></tr><tr key=array-94><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">例如第一个是" 系统时间"的开关</span></td><td key=5></td></tr><tr key=0-1-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> watermarkText</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印文字内容</span></td><td key=5></td></tr><tr key=0-1-13><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> watermarkTextCss</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印文字样式, json字符串 {"color":"#9aba60","opacity":29,"size":14,"location":4}  Opacity表示透明度 采用0~100的整数表示，即0表示透明，100表示不透明。  location表示位置-1:左上;2:左下;3:右上(默认);4:右下。 mode表示显示方式 {1、静止显示；2、随机显示；3、循环滚动} size表示文字大小 {12 -> 48}</span></td><td key=5></td></tr><tr key=0-1-14><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> watermarkPicture</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印图片（上传存储后的文件id）</span></td><td key=5></td></tr><tr key=0-1-15><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pictureDownloadUrl</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印图片（下载地址）</span></td><td key=5></td></tr><tr key=0-1-16><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> watermarkPictureCss</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">水印图片样式, json字符串，"location":1,"mode":1,"opacity":57}  Opacity表示透明度 采用0~100的整数表示，即0表示透明，100表示不透明。location表示位置-1:左上;2:左下;3:右上(默认);4:右下。mode表示显示方式 {1、静止显示；2、随机显示；3、循环滚动}</span></td><td key=5></td></tr><tr key=0-1-17><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> autoAudit</span></td><td key=1><span>boolean</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动审核{false：否 （默认）；true：是}</span></td><td key=5></td></tr><tr key=0-1-18><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordLayoutMode</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制布局模式  1、默认布局  2、自定义布局  3、跟随会议</span></td><td key=5></td></tr><tr key=0-1-19><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordUsers</span></td><td key=1><span>integer []</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">指定用户录制</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>integer</span></p></td></tr><tr key=array-95><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户id</span></td><td key=5></td></tr><tr key=0-1-20><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordLayoutCode</span></td><td key=1><span>string []</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自定义录制方案编码</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>string</span></p></td></tr><tr key=array-96><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">方案编码</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u7ed9u7528u6237u6388u6743u4f1au8baeu5ba40a3ca20id3du7ed9u7528u6237u6388u6743u4f1au8baeu5ba463483e203ca3e">给用户授权会议室
<a id=给用户授权会议室6348> </a></h2>
<p></p>
<h3 id="-63">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/authRoom</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-64">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomUserStr</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">授权者名单格式：’用户名,权限值‘ 或 ’会议室ID,权限值‘ 多个用‘#’号隔开， 例： paul,0#Mike,1#king,2 ;权限值定义： 2 参会人 3 管理员；权限值为0时，表示取消该用户会议室权限；</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名支持汉字、英文字母a-zA-Z、数字0-9、英文下划线,长度在1-32位之间</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-65">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userNodeId</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> online</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> seatList</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> role</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u7ed9u4f1au8baeu5ba4u6388u6743u7528u62370a3ca20id3du7ed9u4f1au8baeu5ba4u6388u6743u7528u623763483e203ca3e">给会议室授权用户
<a id=给会议室授权用户6348> </a></h2>
<p></p>
<h3 id="-66">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/authUser</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-67">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomUserStr</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">授权者名单格式：’用户名,权限值‘ 或 ’会议室ID,权限值‘ 多个用‘#’号隔开， 例： paul,0#Mike,1#king,2 ;权限值定义：2 参会人 3 管理员；权限值为0时，表示取消该用户会议室权限；会议ID为0时，则授予全部会议室。</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> authType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">授权类型
0 全量授权（把这个会议室以前授权的用户都删除了，然后写上现在接口丢上来的用户） 1 增量授权（默认）（把现在接口丢上来的用户加到会议室以前已授权的用户里面）</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-68">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u8bf7u51fau7528u62370a3ca20id3du8bf7u51fau7528u623763483e203ca3e">请出用户
<a id=请出用户6348> </a></h2>
<p></p>
<h3 id="-69">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/kickOut</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-70">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> appBackNotify</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">应用返回提示,允许用户自定义提示信息，如果为空则提示“对不起，会议室已关闭！”</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> operator</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">操作者， 允许用户自定义功能的操作者，如果为空提示“系统管理员”</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userFieldType</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户属性类型, 1:根据用户ID发送文字，2： 根据用户名称发送文字</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userFieldValue</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户属性值,1. userFieldType为1 时， userFieldValue应填用户ID,用户ID之间用#隔开，例如:'10001#10002';2. userFieldType为2 时， userFieldValue应填用户名称,用户名称之间用#隔开，例如: 'mike#king';3. 如果用户不在会议室中，也返回成功。</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-71">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u5220u9664u4f1au8baeu5ba40a3ca20id3du5220u9664u4f1au8baeu5ba463483e203ca3e">删除会议室
<a id=删除会议室6348> </a></h2>
<p></p>
<h3 id="-72">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/delRoomInfo</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-73">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-74">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u6e05u7a7au4f1au8baeu5ba40a3ca20id3du6e05u7a7au4f1au8baeu5ba463483e203ca3e">清空会议室
<a id=清空会议室6348> </a></h2>
<p></p>
<h3 id="-75">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/cleanRoom</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-76">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> appBackNotify</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">应用返回提示,允许用户自定义提示信息，如果为空则提示“对不起，会议室已关闭！”</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> operator</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">操作者， 允许用户自定义功能的操作者，如果为空提示“系统管理员”</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userFieldType</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户属性类型, 1:根据用户ID发送文字，2： 根据用户名称发送文字</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userFieldValue</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户属性值,1. userFieldType为1 时， userFieldValue应填用户ID,用户ID之间用#隔开，例如:'10001#10002';2. userFieldType为2 时， userFieldValue应填用户名称,用户名称之间用#隔开，例如: 'mike#king';3. 如果用户不在会议室中，也返回成功。</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-77">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u66f4u65b0u4f1au8baeu5ba4u72b6u60010a3ca20id3du66f4u65b0u4f1au8baeu5ba4u72b6u600163483e203ca3e">更新会议室状态
<a id=更新会议室状态6348> </a></h2>
<p></p>
<h3 id="-78">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/editRoomStatus</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-79">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室状态: 0 关闭 ， 1 启用。不传值不改变状态，默认为1</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-80">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u5e03u5c400a3ca20id3du4feeu6539u4f1au8baeu5ba4u5e03u5c4063483e203ca3e">修改会议室布局
<a id=修改会议室布局6348> </a></h2>
<p></p>
<h3 id="-81">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/layout</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-82">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> layoutCode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室布局,默认为：layout_freely_divided ， 可选值
laout_data_video_tiled标准（数据+视频 平铺）
layout_data数据
layout_training培训
layout_square_11分屏
layout_square_22分屏
layout_pip画中画
layout_square_44分屏
layout_square_66分屏
layout_square_99分屏
layout_square_1212分屏
layout_square_1616分屏
layout_square_2525分屏
layout_square_3636分屏
layout_square_4949分屏
layout_square_6464分屏
layout_focus_1视频1焦点
layout_focus_2视频2焦点
layout_freely_divided视频焦点（均分）</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-83">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u57fau672cu53c2u65700a3ca20id3du4feeu6539u4f1au8baeu5ba4u57fau672cu53c2u657063483e203ca3e">修改会议室基本参数
<a id=修改会议室基本参数6348> </a></h2>
<p></p>
<h3 id="-84">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/editRoomInfo</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-85">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名</span></td><td key=5><p key=0><span style="font-weight: '700'">最大长度: </span><span>64</span></p><p key=1><span style="font-weight: '700'">最小长度: </span><span>1</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室密码 当登录校验模型为会议室密码验证时，不允许为空。4-32位</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许最大用户数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">校验模型: 1、用户密码验证 2、会议室密码验证 3、匿名登录</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">主席密码</span></td><td key=5></td></tr><tr key=0-6><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用主席密码:0，不启用 , 1 启用</span></td><td key=5></td></tr><tr key=0-7><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">所属组织ID</span></td><td key=5></td></tr><tr key=0-8><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> menteeAdvance</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许所有参会人在管理员进前加入会议(false.不允许; true.允许)</span></td><td key=5></td></tr><tr key=0-9><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> enableInvite</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否允许邀请码登录(false.不允许; true.允许)</span></td><td key=5></td></tr><tr key=0-10><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> autoRecord</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">自动录制: 0 否 ， 1 是</span></td><td key=5></td></tr><tr key=0-11><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议模式: "standard", "discussion", "training"</span></td><td key=5></td></tr><tr key=0-12><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> callBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">H323码率</span></td><td key=5></td></tr><tr key=0-13><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> meetingMinutes</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否开启会议纪要</span></td><td key=5></td></tr><tr key=0-14><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> terminalReInvite</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否终端掉线重邀</span></td><td key=5></td></tr><tr key=0-15><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> additionParam</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预留字段，发送内容示例：{"bid_num":"测试-评标会"} ， 注意：bid_num代表标段信息</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-86">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u6a21u677f0a3ca20id3du4feeu6539u4f1au8baeu5ba4u6a21u677f63483e203ca3e">修改会议室模板
<a id=修改会议室模板6348> </a></h2>
<p></p>
<h3 id="-87">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/permission</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-88">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomMode</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室模式 : standard：标准, discussion：讨论, training：培训, custom：自定义</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomPermission</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室权限，对应模板配置表code编码，当roomMode=custom时候才需要传</span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> autoBroadcastOwnAudio</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">入会自动打开参与人麦克风，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> autoBroadcastOwnVideo</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">入会自动打开参与人视频，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> operatePublicChat</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">群聊，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> operatePrivateChat</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">私聊，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> markWhiteboard</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">标注白板，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> saveWhiteboard</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">保存白板，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> operateMeetingRecord</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">录制会议，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> fileShare</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">文件分享，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> reservePresenterVideo</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">主讲变更时，保留主讲的视频，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> broadcastOwnAudio</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许参会人在会中打开自己的麦克风，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> broadcastOwnVideo</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">允许参会人在会中打开自己的视频，默认为false,需更改传true</span></td><td key=5></td></tr><tr key=0-2-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> modifySelfUserInfo</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否允许用户修改昵称;false:否;true:是;</span></td><td key=5></td></tr><tr key=0-2-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> openUserAvRequiresRequest</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">远程开启音视频是否需要用户同意,默认值true;false:否;true:是;</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-89">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u4e3au5468u4f8bu4f1au8baeu5ba40a3ca20id3du4feeu6539u4f1au8baeu5ba4u4e3au5468u4f8bu4f1au8baeu5ba463483e203ca3e">修改会议室为周例会议室
<a id=修改会议室为周例会议室6348> </a></h2>
<p></p>
<h3 id="-90">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/routine</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-91">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例循环模式: 1 每天，2 每周，3 每月</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：yyyy-MM-dd  HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：yyyy-MM-dd  HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每个星期几: 0周一，1周二，2周三，3周四，4周五，5周六, 6周日（cycleFlag为2时不空）</span></td><td key=5></td></tr><tr key=0-5><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每月的几号: 大于零，小于等于31的数值（cycleFlag为3时不空）</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-92">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">RoomUpdDto</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例循环模式: 1 每天，2 每周，3 每月</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每月的几号: 大于零，小于等于31的数值（cycleFlag为3时不空）</span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频码流: 10-3000（kbps）之间；默认为128；当启用默认视频参数时，不得为空。其余情况，填入0;</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频编码器: 3 H.264 , 2 MPEG4 ; (默认 H.264)</span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认分辨率: 参数为：4到8；4 640*480;5 704*576;6 720*576;7 1280*720;8 1920*1080,需要授权文件允许，默认4（640*480）</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定结束时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定开始时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用默认视频参数: 1 启用默认视频参数，0 不启用默认视频参数</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每个星期几: 0周一，1周二，2周三，3周四，4周五，5周六, 6周日（cycleFlag为2时不空）</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u4e3au9884u7ea6u4f1au8baeu5ba40a3ca20id3du4feeu6539u4f1au8baeu5ba4u4e3au9884u7ea6u4f1au8baeu5ba463483e203ca3e">修改会议室为预约会议室
<a id=修改会议室为预约会议室6348> </a></h2>
<p></p>
<h3 id="-93">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/reservation</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-94">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定结束时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定开始时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> scheduleAdvance</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3>false</td><td key=4><span style="white-space: pre-wrap">允许提前进入预约会议室(false.不允许; true.允许）</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> extension</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3>false</td><td key=4><span style="white-space: pre-wrap">允许会议延期(false.不允许; true.允许)</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-95">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">RoomUpdDto</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例循环模式: 1 每天，2 每周，3 每月</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每月的几号: 大于零，小于等于31的数值（cycleFlag为3时不空）</span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频码流: 10-3000（kbps）之间；默认为128；当启用默认视频参数时，不得为空。其余情况，填入0;</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频编码器: 3 H.264 , 2 MPEG4 ; (默认 H.264)</span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认分辨率: 参数为：4到8；4 640*480;5 704*576;6 720*576;7 1280*720;8 1920*1080,需要授权文件允许，默认4（640*480）</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定结束时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定开始时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用默认视频参数: 1 启用默认视频参数，0 不启用默认视频参数</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每个星期几: 0周一，1周二，2周三，3周四，4周五，5周六, 6周日（cycleFlag为2时不空）</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u4e3au56fau5b9au4f1au8baeu5ba40a3ca20id3du4feeu6539u4f1au8baeu5ba4u4e3au56fau5b9au4f1au8baeu5ba463483e203ca3e">修改会议室为固定会议室
<a id=修改会议室为固定会议室6348> </a></h2>
<p></p>
<h3 id="-96">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/fixed</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-97">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-98">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">RoomUpdDto</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例循环模式: 1 每天，2 每周，3 每月</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每月的几号: 大于零，小于等于31的数值（cycleFlag为3时不空）</span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频码流: 10-3000（kbps）之间；默认为128；当启用默认视频参数时，不得为空。其余情况，填入0;</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频编码器: 3 H.264 , 2 MPEG4 ; (默认 H.264)</span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认分辨率: 参数为：4到8；4 640*480;5 704*576;6 720*576;7 1280*720;8 1920*1080,需要授权文件允许，默认4（640*480）</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定结束时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定开始时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用默认视频参数: 1 启用默认视频参数，0 不启用默认视频参数</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每个星期几: 0周一，1周二，2周三，3周四，4周五，5周六, 6周日（cycleFlag为2时不空）</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u4feeu6539u4f1au8baeu5ba4u662fu5426u542fu7528u9ed8u8ba4u89c6u9891u914du7f6e0a3ca20id3du4feeu6539u4f1au8baeu5ba4u662fu5426u542fu7528u9ed8u8ba4u89c6u9891u914du7f6e63483e203ca3e">修改会议室是否启用默认视频配置
<a id=修改会议室是否启用默认视频配置6348> </a></h2>
<p></p>
<h3 id="-99">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/defaultSetting</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-100">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频码流: 10-3000（kbps）之间；默认为128；当启用默认视频参数时，不得为空。其余情况，填入0;</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频编码器: 3 H.264 ,传3</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认分辨率: 参数为3 352*288(普清);4 640*480;5 704*576;6 720*576; 7 1280*720;8 1920*1080;10 3840*2160(4K) 需要授权文件允许，默认3（352*288）</span></td><td key=5></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用默认视频参数: 0 启用默认视频参数，1 自定义视频参数。当useDefaultFlag的值为1时，自定义的参数defaultVideoCodec、defaultVideoWind、defaultVideoBitrate的值必填</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-101">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">RoomUpdDto</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">周例循环模式: 1 每天，2 每周，3 每月</span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每月的几号: 大于零，小于等于31的数值（cycleFlag为3时不空）</span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频码流: 10-3000（kbps）之间；默认为128；当启用默认视频参数时，不得为空。其余情况，填入0;</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认视频编码器: 3 H.264 , 2 MPEG4 ; (默认 H.264)</span></td><td key=5></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">默认分辨率: 参数为：4到8；4 640*480;5 704*576;6 720*576;7 1280*720;8 1920*1080,需要授权文件允许，默认4（640*480）</span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定结束时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">预定开始时间,格式：yyyy-MM-dd HH:mm:ss；会议室类型为预约会议室时，不允许为空</span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否启用默认视频参数: 1 启用默认视频参数，0 不启用默认视频参数</span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：HH:mm:ss,会议室类型为周例会议室时，不允许为空</span></td><td key=5></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每个星期几: 0周一，1周二，2周三，3周四，4周五，5周六, 6周日（cycleFlag为2时不空）</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u4f1au8baeu5ba4u5217u88680a3ca20id3du83b7u53d6u4f1au8baeu5ba4u5217u886863483e203ca3e">获取会议室列表
<a id=获取会议室列表6348> </a></h2>
<p></p>
<h3 id="-102">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/roomList</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-103">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID，有具体数值时进行精确查询</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> searchKey</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室名称查询，搜索关键字为空，且搜索类型0时，视为空。</span></td><td key=5></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> searchType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">搜索类型 类型值0为前后模糊搜索，1全匹配</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-104">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">PageVO«RoominfoBean»</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">当前页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总页数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">查询数据列表</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-2-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> creatorId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> curUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-3><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> currentServiceId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-4><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-5><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-6><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-7><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-8><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-9><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoQos</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-10><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoQuality</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-11><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-12><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-13><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-14><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> enableRecord</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-15><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> endTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-16><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-17><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-18><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-19><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-20><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> recordEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-21><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> recordStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-22><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomAppId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-23><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomDesc</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-24><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-25><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-26><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-27><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> startTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-28><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-29><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-30><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-31><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-32><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-33><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-34><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> inviteCode</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">出席邀请码</span></td><td key=5></td></tr><tr key=0-1-2-35><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> chairmanInviteCode</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">主持人邀请码</span></td><td key=5></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示条数，默认 5</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u4f1au8baeu5ba4u767bu5f55u5730u57400a3ca20id3du83b7u53d6u4f1au8baeu5ba4u767bu5f55u5730u574063483e203ca3e">获取会议室登录地址
<a id=获取会议室登录地址6348> </a></h2>
<p></p>
<h3 id="-105">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/loginAddr</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-106">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<h3 id="-107">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>string []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>string</span></p></td></tr><tr key=array-97><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u6309u7167u4f1au8baeu65f6u95f4u67e5u8be2u4f1au8baeu8be6u60c50a3ca20id3du6309u7167u4f1au8baeu65f6u95f4u67e5u8be2u4f1au8baeu8be6u60c563483e203ca3e">按照会议时间查询会议详情
<a id=按照会议时间查询会议详情6348> </a></h2>
<p></p>
<h3 id="-108">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/meetingLog</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-109">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> endTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：yyyy-MM-dd HH:mm:ss</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> startTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：yyyy-MM-dd HH:mm:ss</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-110">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> duration</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUser</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingID</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomID</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u67e5u8be2u4f01u4e1au7684u5f53u524du4f1au8baeuff08u5f53u524du5728u7ebfu7684u4f1au8baeu5ba4uff090a3ca20id3du67e5u8be2u4f01u4e1au7684u5f53u524du4f1au8baeuff08u5f53u524du5728u7ebfu7684u4f1au8baeu5ba4uff0963483e203ca3e">查询企业的当前会议（当前在线的会议室）
<a id=查询企业的当前会议（当前在线的会议室）6348> </a></h2>
<p></p>
<h3 id="-111">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/onlineRoom</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-112">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">组织机构ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-113">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">PageVO«RoominfoBean»</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">当前页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总页数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">查询数据列表</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-2-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> creatorId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> curUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-3><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> currentServiceId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-4><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-5><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-6><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-7><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-8><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-9><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoQos</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-10><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoQuality</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-11><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-12><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-13><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-14><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> enableRecord</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-15><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> endTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-16><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-17><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-18><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-19><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-20><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> recordEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-21><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> recordStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-22><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomAppId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-23><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomDesc</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-24><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-25><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-26><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-27><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> startTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2-28><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-29><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-30><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-31><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-32><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-33><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示条数，默认 5</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u67e5u8be2u4f1au8baeu5ba4u53c2u4f1au4ebau4fe1u606f0a3ca20id3du67e5u8be2u4f1au8baeu5ba4u53c2u4f1au4ebau4fe1u606f63483e203ca3e">查询会议室参会人信息
<a id=查询会议室参会人信息6348> </a></h2>
<p></p>
<h3 id="-114">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/roomLog</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<p>查询本企业参会人进出会议记录，可按指定时间段查询；<br>
departId 为空时，默认查询本企业全部组织</p>
<h3 id="-115">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> departId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">部门ID，默认查本企业全部参会人进会，离会记录</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> endTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结束时间,格式：yyyy-MM-dd HH:mm:ss</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> startTime</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">开始时间,格式：yyyy-MM-dd HH:mm:ss</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-116">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> duration</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enterTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> leaveTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> logId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> meetingId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> serviceId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userIP</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u4f1au8baeu5ba4u5f53u524du4ebau65700a3ca20id3du83b7u53d6u4f1au8baeu5ba4u5f53u524du4ebau657063483e203ca3e">获取会议室当前人数
<a id=获取会议室当前人数6348> </a></h2>
<p></p>
<h3 id="-117">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/userNum</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-118">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-119">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">RoominfoBean</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> curUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u67d0u4e2au7528u6237u662fu5426u5728u4f1au8baeu4e2d0a3ca20id3du83b7u53d6u67d0u4e2au7528u6237u662fu5426u5728u4f1au8baeu4e2d63483e203ca3e">获取某个用户是否在会议中
<a id=获取某个用户是否在会议中6348> </a></h2>
<p></p>
<h3 id="-120">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/userInRoom</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-121">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userName</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户名支持汉字、英文字母a-zA-Z、数字0-9、英文下划线,长度在1-32位之间</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-122">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> flag</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u7528u6237u6709u6743u9650u7684u4f1au8baeu5ba4u5217u88680a3ca20id3du83b7u53d6u7528u6237u6709u6743u9650u7684u4f1au8baeu5ba4u5217u886863483e203ca3e">获取用户有权限的会议室列表
<a id=获取用户有权限的会议室列表6348> </a></h2>
<p></p>
<h3 id="-123">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/roomList/{userName}</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-124">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>userName</td>
<td></td>
<td>userName</td>
</tr>
</tbody>
</table>
<h3 id="-125">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> chairPassword</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> creatorId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> curUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> currentServiceId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> cycleFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> dateEveyMonth</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-7><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoBitrate</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-8><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoCodec</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-9><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoQos</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-10><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoQuality</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-11><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> defaultVideoWind</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-12><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-13><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableChairPwd</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-14><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> enableRecord</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-15><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> endTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-16><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-17><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> hopeStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-18><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> maxUserCount</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-19><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-20><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-21><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> recordStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-22><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomAppId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-23><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomDesc</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-24><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-25><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-26><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomType</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-27><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> startTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>date-time</span></p></td></tr><tr key=0-1-28><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-29><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> useDefaultFlag</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-30><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> verifyMode</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-31><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekEndTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-32><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weekStartTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-33><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> weeks</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u4f1au8baeu5f53u524du7528u6237u5217u88680a3ca20id3du83b7u53d6u4f1au8baeu5f53u524du7528u6237u5217u886863483e203ca3e">获取会议当前用户列表
<a id=获取会议当前用户列表6348> </a></h2>
<p></p>
<h3 id="-126">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/participant</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-127">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-128">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>string []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>string</span></p></td></tr><tr key=array-98><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> </span></td><td key=1><span></span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u83b7u53d6u6307u5b9au4f1au8baeu5ba4u6388u6743u7684u7528u6237u5217u88680a3ca20id3du83b7u53d6u6307u5b9au4f1au8baeu5ba4u6388u6743u7684u7528u6237u5217u886863483e203ca3e">获取指定会议室授权的用户列表
<a id=获取指定会议室授权的用户列表6348> </a></h2>
<p></p>
<h3 id="-129">基本信息</h3>
<p><strong>Path：</strong> /api/v1/user/roomUserList</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-130">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageNumber</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">页码，默认是第一页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> pageSize</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示的记录数 默认为10</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr>
               </tbody>
              </table>
<h3 id="-131">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">PageVO«UserinfoBean»</span></td><td key=5></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">当前页</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总页数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">查询数据列表</span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-2-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> adminRole</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> departId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> displayName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-3><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> email</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-4><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> mobile</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-5><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> password</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-6><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> sex</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-7><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-8><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> telePhone</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-9><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userLevel</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-10><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userName</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2-11><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-2-12><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">每页显示条数，默认 5</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">总数</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u53d1u9001u6587u5b57u5230u6307u5b9au4f1au8baeu5ba4u7684u7528u62370a3ca20id3du53d1u9001u6587u5b57u5230u6307u5b9au4f1au8baeu5ba4u7684u7528u623763483e203ca3e">发送文字到指定会议室的用户
<a id=发送文字到指定会议室的用户6348> </a></h2>
<p></p>
<h3 id="-132">基本信息</h3>
<p><strong>Path：</strong> /api/v1/room/sendMsg</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h3 id="-133">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>Authorization</td>
<td>String</td>
<td>是</td>
<td>aa.bb.cc</td>
<td>详见 \鉴权相关说明 文档</td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> appBackNotify</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">应用返回提示,允许用户自定义提示信息，如果为空则提示“对不起，会议室已关闭！”</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> operator</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">操作者， 允许用户自定义功能的操作者，如果为空提示“系统管理员”</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> roomId</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会议室ID</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-3><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userFieldType</span></td><td key=1><span>integer</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户属性类型, 1:根据用户ID发送文字，2： 根据用户名称发送文字</span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-4><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> userFieldValue</span></td><td key=1><span>string</span></td><td key=2>必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">用户属性值,1. userFieldType为1 时， userFieldValue应填用户ID,用户ID之间用#隔开，例如:'10001#10002';2. userFieldType为2 时， userFieldValue应填用户名称,用户名称之间用#隔开，例如: 'mike#king';3. 如果用户不在会议室中，也返回成功。</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-134">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-1-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> online</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>byte</span></p></td></tr><tr key=0-1-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> role</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> seatList</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userId</span></td><td key=1><span>integer</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=2><span style="font-weight: '700'">format: </span><span>int32</span></p></td></tr><tr key=0-1-5><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userNodeId</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1-6><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> userRight</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=4><span style="font-weight: '700'">format: </span><span>byte</span></p></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h1 id="u4f1au63a7u63a5u53e3">会控接口</h1>
<p></p>
<h2 id="u4f1au4e2du63a7u52360a3ca20id3du4f1au4e2du63a7u523663553e203ca3e">会中控制
<a id=会中控制6355> </a></h2>
<p></p>
<h3 id="-135">基本信息</h3>
<p><strong>Path：</strong> /api/v1/control/{roomId}</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<p>接口入参 <strong>param</strong> 与响应 <strong>data</strong> 与入参 <strong>operate</strong> 相关，分为以下几类：</p>
<ul>
<li>无参请求</li>
<li>有参请求</li>
</ul>
<h3>关闭会议</h3>
<p><strong>operate</strong> CLOSE</p>
<p><strong>param</strong> 无</p>
<p><strong>data</strong> 无</p>
<h3>全体静音</h3>
<p><strong>operate</strong> MUTE_ALL</p>
<p><strong>param</strong> 无</p>
<p><strong>data</strong> 无</p>
<h3>会议锁定</h3>
<p><strong>operate</strong> MEETING_LOCK</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>lock</td>
<td>number</td>
<td>0 取消锁定 1 锁定</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "MEETING_LOCK",
  "param": {
    "lock": 0
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>邀请入会</h3>
<p><strong>operate</strong> INVITE_USER</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>string</td>
<td>主叫名称, 长度不得大于32</td>
</tr>
<tr>
<td>users</td>
<td>array</td>
<td>用户ID 列表</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "INVITE_USER",
  "param": {
    "name": "会控用户",
    "users": [
      1,
      2,
      3
    ]
  }
}
</code></pre>
<p><strong>data</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>errors</td>
<td>array</td>
<td>失败的用户ID 列表</td>
</tr>
</tbody>
</table>
<pre><code data-language="json" class="lang-json">{
  "code": "0",
  "msg": "SUCCESS",
  "data": {
    "result": 0,
    "errors": [
      2
    ]
  }
}
</code></pre>
<h3>终端呼叫</h3>
<p><strong>operate</strong> INVITE_TERMINAL</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>callType</td>
<td>number</td>
<td>1 电话用户 2 H323终端</td>
</tr>
<tr>
<td>callInfo</td>
<td>array</td>
<td></td>
</tr>
<tr>
<td>|-calleeNumber</td>
<td>string</td>
<td>被叫号码, 最大长度256</td>
</tr>
<tr>
<td>|-calleeNickname</td>
<td>string</td>
<td>被叫用户昵称, 最大长度256</td>
</tr>
<tr>
<td>|-calleeUserId</td>
<td>string</td>
<td>被叫用户的会议室用户ID，非0有效</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "INVITE_TERMINAL",
  "param": {
    "callback": "http://127.0.0.1:8088",
    "callType": 0,
    "callInfo": [
      {
        "calleeNumber": "",
        "calleeNickname": "",
        "calleeUserId": 0
      }
    ]
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>字幕设置</h3>
<p><strong>operate</strong> SEND_SUBTITLES</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>fontSize</td>
<td>number</td>
<td>字体大小 1 小 2 中 3大</td>
</tr>
<tr>
<td>fontColor</td>
<td>number</td>
<td>字体颜色 例如：0xAABBCC  AA为红色的数值 BB为绿色的数值  CC为蓝色的数值，数值的范围均为0x0~0xFF</td>
</tr>
<tr>
<td>type</td>
<td>number</td>
<td>字幕类型 0 滚动  2 固定</td>
</tr>
<tr>
<td>align</td>
<td>number</td>
<td>字幕位置 0 顶部 1 中间 2 底部</td>
</tr>
<tr>
<td>content</td>
<td>number</td>
<td>字幕内容 最大长度4096</td>
</tr>
<tr>
<td>userId</td>
<td>array</td>
<td>0 表示发送给所有对象</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "SEND_SUBTITLES",
  "param": {
    "fontSize": 2,
    "fontColor": 255,
    "type": 0,
    "align": 0,
    "content": "Hello world",
    "userId": [
      0
    ]
  }
}
</code></pre>
<h3>字幕关闭</h3>
<p><strong>operate</strong> CLOSE_SUBTITLE</p>
<p><strong>param</strong> 无</p>
<p><strong>data</strong> 无</p>
<h3>录制操作</h3>
<p><strong>operate</strong> OP_RECORD</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>state</td>
<td>number</td>
<td>0.未录制(即停止录制) 2.录制中(开启录制)</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "OP_RECORD",
  "param": {
    "state": 0
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>布局设置</h3>
<p><strong>operate</strong> OP_LAYOUT</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>layout</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-mode</td>
<td>number</td>
<td>窗口模式 1 普通模式 2 数据模式 3 视频模式</td>
</tr>
<tr>
<td>|-full</td>
<td>number</td>
<td>是否全屏模式 0 非全屏 1 全屏</td>
</tr>
<tr>
<td>|-dataActive</td>
<td>number</td>
<td>数据当前视图 1 白板 2 屏幕广播 3 WEB共享 4 媒体共享 5 电子投票 6 视频</td>
</tr>
<tr>
<td>|-videoRelayId</td>
<td>number</td>
<td>视频布局ID：1 2 3（画中画） 4 6 9 12 16 25 36 49 64 分屏</td>
</tr>
<tr>
<td>|-fullVideoId</td>
<td>number</td>
<td>视频全屏显示的用户ID</td>
</tr>
<tr>
<td>|-fullVideoMediaId</td>
<td>number</td>
<td>视频全屏用户对应的视频ID</td>
</tr>
<tr>
<td>|-validFullMode</td>
<td>number</td>
<td>保持全屏模式</td>
</tr>
<tr>
<td>|-videoInfo</td>
<td>array</td>
<td>视频信息</td>
</tr>
<tr>
<td>||--userId</td>
<td>number</td>
<td>视频用户ID</td>
</tr>
<tr>
<td>||--mediaId</td>
<td>number</td>
<td>视频通道ID 比如第一个摄像头，id为1，第二个id为2</td>
</tr>
<tr>
<td>||--pos</td>
<td>number</td>
<td>视频显示位置</td>
</tr>
<tr>
<td>|-dstInfo</td>
<td>object</td>
<td>目标信息，客户端以及会控端不用处理此字段</td>
</tr>
<tr>
<td>||--dstUserId</td>
<td>array</td>
<td>目标用户ID</td>
</tr>
<tr>
<td>||--dstTerminalType</td>
<td>array</td>
<td>目标用户终端类型</td>
</tr>
<tr>
<td>||--excludeUserId</td>
<td>array</td>
<td>排除用户ID</td>
</tr>
<tr>
<td>||--excludeTerminalType</td>
<td>array</td>
<td>排除用户终端类型</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "OP_LAYOUT",
  "param": {
    "layout": {
      "mode": 0,
      "full": 0,
      "dataActive": 0,
      "videoRelayId": 0,
      "fullVideoId": 0,
      "fullVideoMediaId": 0,
      "validFullMode": 0,
      "videoInfo": [
        {
          "userId": 0,
          "mediaId": 0,
          "pos": 0
        }
      ],
      "dstInfo": {
        "dstUserId": [],
        "dstTerminalType": [],
        "excludeUserId": [],
        "excludeTerminalType": []
      }
    }
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>会议重命名</h3>
<p><strong>operate</strong> MEETING_RENAME</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomName</td>
<td>string</td>
<td>会议新名称，最大长度256</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "MEETING_RENAME",
  "param": {
    "roomName": "Hello"
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>设置用户为管理员</h3>
<p><strong>operate</strong> OP_ROLE_MANAGER</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>state</td>
<td>number</td>
<td>0 非管理员状态 2 管理员状态</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "OP_ROLE_MANAGER",
  "param": {
    "userId": 0,
    "state": 0
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>设置用户为主讲</h3>
<p><strong>operate</strong> OP_ROLE_PRESENTER</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>state</td>
<td>number</td>
<td>0 非主讲状态 2 主讲状态</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "OP_ROLE_PRESENTER",
  "param": {
    "userId": 0,
    "state": 0
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>请出用户</h3>
<p><strong>operate</strong> USER_REMOVE</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "USER_REMOVE",
  "param": {
    "userId": 0
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>控制用户音频</h3>
<p><strong>operate</strong> USER_AUDIO_CONTROL</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>audioState</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-deviceId</td>
<td>number</td>
<td>设备id 比如第一个音频设备1，第一个音频设备0</td>
</tr>
<tr>
<td>|-state</td>
<td>number</td>
<td>0 设备未广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "USER_AUDIO_CONTROL",
  "param": {
    "userId": 0,
    "audioState": {
      "deviceId": 0,
      "state": 0
    }
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>控制用户视频</h3>
<p><strong>operate</strong> USER_VIDEO_CONTROL</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>videoState</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-deviceId</td>
<td>number</td>
<td>设备id 比如第一个摄像头1，第二个摄像头0</td>
</tr>
<tr>
<td>|-state</td>
<td>number</td>
<td>0 设备未广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "USER_VIDEO_CONTROL",
  "param": {
    "userId": 0,
    "videoState": {
      "deviceId": 0,
      "state": 0
    }
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>用户重命名</h3>
<p><strong>operate</strong> USER_RENAME</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>nickname</td>
<td>string</td>
<td>用户名称，最大长度256</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "USER_RENAME",
  "param": {
    "userId": 0,
    "nickname": ""
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>用户信息查询</h3>
<p><strong>operate</strong> USER_INFO</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>userName</td>
<td>string</td>
<td>用户名称，最大长度256</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "USER_INFO",
  "param": {
    "userId": 0,
    "userName": ""
  }
}
</code></pre>
<p><strong>data</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>|-nickname</td>
<td>string</td>
<td>昵称</td>
</tr>
<tr>
<td>|-userName</td>
<td>string</td>
<td>用户名</td>
</tr>
<tr>
<td>|-userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>|-userIp</td>
<td>string</td>
<td>用户IP</td>
</tr>
<tr>
<td>|-managerState</td>
<td>number</td>
<td>0 非管理员状态 2 管理员状态</td>
</tr>
<tr>
<td>|-presenterState</td>
<td>number</td>
<td>0 非主讲状态  2 主讲状态</td>
</tr>
<tr>
<td>|-terminalType</td>
<td>number</td>
<td>用户终端类型</td>
</tr>
<tr>
<td>|-audioState</td>
<td>array</td>
<td>音频状态</td>
</tr>
<tr>
<td>|--deviceId</td>
<td>number</td>
<td>音频设备ID, 从1开始</td>
</tr>
<tr>
<td>|--state</td>
<td>number</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
<tr>
<td>|-videoState</td>
<td>array</td>
<td>视频状态</td>
</tr>
<tr>
<td>|--deviceId</td>
<td>number</td>
<td>视频设备ID, 从1开始</td>
</tr>
<tr>
<td>|--state</td>
<td>number</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<h3>用户列表查询</h3>
<p><strong>operate</strong> USER_LIST</p>
<p><strong>param</strong></p>
<p>无</p>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "USER_LIST",
  "param": {}
}
</code></pre>
<p><strong>data</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userInfo</td>
<td>array</td>
<td>用户信息</td>
</tr>
<tr>
<td>|-nickname</td>
<td>string</td>
<td>昵称</td>
</tr>
<tr>
<td>|-userName</td>
<td>string</td>
<td>用户名</td>
</tr>
<tr>
<td>|-userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>|-userIp</td>
<td>string</td>
<td>用户IP</td>
</tr>
<tr>
<td>|-managerState</td>
<td>number</td>
<td>0 非管理员状态 2 管理员状态</td>
</tr>
<tr>
<td>|-presenterState</td>
<td>number</td>
<td>0 非主讲状态  2 主讲状态</td>
</tr>
<tr>
<td>|-terminalType</td>
<td>number</td>
<td>用户终端类型</td>
</tr>
<tr>
<td>|-audioState</td>
<td>array</td>
<td>音频状态</td>
</tr>
<tr>
<td>|--deviceId</td>
<td>number</td>
<td>音频设备ID, 从1开始</td>
</tr>
<tr>
<td>|--state</td>
<td>number</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
<tr>
<td>|-videoState</td>
<td>array</td>
<td>视频状态</td>
</tr>
<tr>
<td>|--deviceId</td>
<td>number</td>
<td>视频设备ID, 从1开始</td>
</tr>
<tr>
<td>|--state</td>
<td>number</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<pre><code data-language="json" class="lang-json">{
  "code": "0",
  "msg": "SUCCESS",
  "data": {
    "result": 0,
    "userInfo": [
      {
        "nickname": "hunter",
        "userName": "hunter",
        "userId": 1610612739,
        "managerState": 0,
        "presenterState": 0,
        "terminalType": 21,
        "audioState": [
          {
            "deviceId": 1,
            "state": 0
          }
        ],
        "videoState": [
          {
            "deviceId": 1,
            "state": 0
          },
          {
            "deviceId": 2,
            "state": 0
          }
        ]
      }
    ]
  }
}
</code></pre>
<h3>会议信息查询</h3>
<p><strong>operate</strong> MEETING_INFO</p>
<p><strong>param</strong> 无</p>
<p>示例:</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "MEETING_INFO",
  "param": null
}
</code></pre>
<p><strong>data</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>meetingId</td>
<td>number</td>
<td>会议ID，最大长度128</td>
</tr>
<tr>
<td>roomName</td>
<td>string</td>
<td>会议室名称，最大长度256</td>
</tr>
<tr>
<td>lockState</td>
<td>string</td>
<td>锁定状态 0 没有锁定 1 锁定</td>
</tr>
<tr>
<td>subtitleState</td>
<td>string</td>
<td>字幕状态 0 会议室没有字幕 1 会议室有字幕</td>
</tr>
<tr>
<td>recordState</td>
<td>string</td>
<td>录制状态 0 未录制 2录制中</td>
</tr>
<tr>
<td>layout</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-mode</td>
<td>number</td>
<td>窗口模式 1 普通模式 2 数据模式 3 视频模式</td>
</tr>
<tr>
<td>|-full</td>
<td>number</td>
<td>是否全屏模式 0 非全屏 1 全屏</td>
</tr>
<tr>
<td>|-dataActive</td>
<td>number</td>
<td>数据当前视图 1 白板 2 屏幕广播 3 WEB共享 4 媒体共享 5 电子投票 6 视频</td>
</tr>
<tr>
<td>|-videoRelayId</td>
<td>number</td>
<td>视频布局ID：1 2 3（画中画） 4 6 9 12 16 25 36 49 64 分屏</td>
</tr>
<tr>
<td>|-fullVideoId</td>
<td>number</td>
<td>视频全屏显示的用户ID</td>
</tr>
<tr>
<td>|-fullVideoMediaId</td>
<td>number</td>
<td>视频全屏用户对应的视频ID</td>
</tr>
<tr>
<td>|-validFullMode</td>
<td>number</td>
<td>保持全屏模式</td>
</tr>
<tr>
<td>|-videoInfo</td>
<td>array</td>
<td>视频信息</td>
</tr>
<tr>
<td>||--userId</td>
<td>number</td>
<td>视频用户ID</td>
</tr>
<tr>
<td>||--mediaId</td>
<td>number</td>
<td>视频通道ID 比如第一个摄像头，id为0，第二个id为1</td>
</tr>
<tr>
<td>||--pos</td>
<td>number</td>
<td>视频显示位置</td>
</tr>
</tbody>
</table>
<p>示例</p>
<pre><code data-language="json" class="lang-json">{
  "code": "0",
  "msg": "SUCCESS",
  "data": {
    "result": 0,
    "meetingId": "{65bb3840-03c4-daac-0100-000000000000}",
    "lockState": 0,
    "subtitleState": 0,
    "recordState": 0,
    "layout": {
      "mode": 3,
      "full": 0,
      "dataActive": 1,
      "videoRelayId": 4,
      "fullVideoId": 0,
      "fullVideoMediaId": 0,
      "validFullMode": 0,
      "videoInfo": []
    },
    "roomName": "+_+"
  }
}
</code></pre>
<h3>布局锁定</h3>
<p><strong>operate</strong> LOCK_LAYOUT</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>lock</td>
<td>string</td>
<td>0 未锁定  1 锁定</td>
</tr>
</tbody>
</table>
<p>示例:</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "LOCK_LAYOUT",
  "param": {
    "lock": 0
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3>添加拉流地址</h3>
<p><strong>operate</strong> PULL_STREAM_ADD</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userName</td>
<td>string</td>
<td>拉流会中用户名称</td>
</tr>
<tr>
<td>leaveMode</td>
<td>string</td>
<td>拉流会中用户离开方式, 0 会议室没有用户就自动退会, 1 会议室没有用户也不退会</td>
</tr>
<tr>
<td>protocolParam</td>
<td>string</td>
<td>协议参数，json字符串，添加协议相关字段，streamType和streamAddr为必传字段</td>
</tr>
</tbody>
</table>
<p>示例:</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "PULL_STREAM_ADD",
  "param": {
    "userName": "xxxx",
    "leaveMode": 0,
    "protocolParam": {
      "streamType": "rtsp",
      "streamAddr": "rtsp://127.0.0.1:554/live"
    }
  }
}
</code></pre>
<p><strong>data</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
</tbody>
</table>
<pre><code data-language="json" class="lang-json">{
  "code": "0",
  "msg": "SUCCESS",
  "data": {
    "result": 0,
    "userId": 123456
  }
}
</code></pre>
<h3>删除推流地址</h3>
<p><strong>operate</strong> PULL_STREAM_DEL</p>
<p><strong>param</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>protocolParam</td>
<td>string</td>
<td>协议参数，json字符串，添加协议相关字段，streamType和streamAddr为必传字段</td>
</tr>
</tbody>
</table>
<p>示例:</p>
<pre><code data-language="json" class="lang-json">{
  "operate": "PULL_STREAM_DEL",
  "param": {
    "protocolParam": "{\"streamType\": \"rtsp\",\"streamAddr\": \"rtsp://127.0.0.1:554/live\"}"
  }
}
</code></pre>
<p><strong>data</strong> 无</p>
<h3 id="-136">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomId</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> operate</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">会控操作枚举, 详见备注</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> param</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">与operate操作关联, 详见备注</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-137">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">操作结果</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">结果描述</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">与operate操作关联, 详见备注</span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> result</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">固定返回，0成功，非0失败</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u8ba2u9605u5220u96640a3ca20id3du8ba2u9605u5220u966463553e203ca3e">订阅删除
<a id=订阅删除6355> </a></h2>
<p></p>
<h3 id="-138">基本信息</h3>
<p><strong>Path：</strong> /api/v1/control/{roomId}/subscriptions</p>
<p><strong>Method：</strong> DELETE</p>
<p><strong>接口描述：</strong></p>
<h3 id="-139">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomId</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> event</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-140">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u8ba2u9605u65b0u589e0a3ca20id3du8ba2u9605u65b0u589e63553e203ca3e">订阅新增
<a id=订阅新增6355> </a></h2>
<p></p>
<h3 id="-141">基本信息</h3>
<p><strong>Path：</strong> /api/v1/control/{roomId}/subscriptions</p>
<p><strong>Method：</strong> POST</p>
<p><strong>接口描述：</strong></p>
<h2>回调请求</h2>
<p>订阅回调后, 当会中出现相应事件时会触发相应的回调, 回调以 HTTP 请求方式实现</p>
<table>
<thead>
<tr>
<th>信息</th>
<th>值</th>
</tr>
</thead>
<tbody>
<tr>
<td>URL</td>
<td>设置的回调地址</td>
</tr>
<tr>
<td>Method</td>
<td>POST</td>
</tr>
</tbody>
</table>
<p><strong>请求头</strong></p>
<table>
<thead>
<tr>
<th>Header</th>
<th>Value</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
</tr>
<tr>
<td>Authorization</td>
<td>鉴权方式与请求方式相同</td>
</tr>
</tbody>
</table>
<p><strong>请求消息</strong></p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>id</td>
<td>string</td>
<td>uuid</td>
</tr>
<tr>
<td>timestamp</td>
<td>number</td>
<td>发生时间戳</td>
</tr>
<tr>
<td>event</td>
<td>string</td>
<td>分类枚举 USER, MEETING, RECORD</td>
</tr>
<tr>
<td>detailType</td>
<td>number</td>
<td>详细类型</td>
</tr>
<tr>
<td>data</td>
<td>object</td>
<td>事件信息, 结构与详细类型对应</td>
</tr>
<tr>
<td>|-- roomId</td>
<td>number</td>
<td>固定字段, 会议室ID</td>
</tr>
<tr>
<td>|-- meetingId</td>
<td>string</td>
<td>固定字段, 会议唯一标识</td>
</tr>
<tr>
<td>|-- xxxx</td>
<td>xxxx</td>
<td>其他字段, 与详细类型对应</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "data": {
    "roomId": 10000,
    "meetingId": "{65ead083-7304-c610-0100-000000000000}"
  },
  "detailType": 202001,
  "event": "RECORD",
  "id": "26aa401f-c6a4-4d80-922d-b76ca433bd8a",
  "timestamp": 1709545770824
}
</code></pre>
<h2>详细类型</h2>
<h3>用户事件</h3>
<h4>用户入会</h4>
<p>detailType: 200000</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userInfo</td>
<td>object</td>
<td>用户信息</td>
</tr>
<tr>
<td>|-nickname</td>
<td>string</td>
<td>昵称</td>
</tr>
<tr>
<td>|-userName</td>
<td>string</td>
<td>用户名</td>
</tr>
<tr>
<td>|-userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>|-managerState</td>
<td>number</td>
<td>0 非管理员状态 2 管理员状态</td>
</tr>
<tr>
<td>|-presenterState</td>
<td>number</td>
<td>0 非主讲状态 2 主讲状态</td>
</tr>
<tr>
<td>|-terminalType</td>
<td>number</td>
<td>用户终端类型</td>
</tr>
<tr>
<td>|-audioState</td>
<td>array</td>
<td>音频状态</td>
</tr>
<tr>
<td>|--deviceId</td>
<td>number</td>
<td>音频设备ID, 从1开始</td>
</tr>
<tr>
<td>|--state</td>
<td>number</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
<tr>
<td>|-videoState</td>
<td>array</td>
<td>视频状态</td>
</tr>
<tr>
<td>|--deviceId</td>
<td>number</td>
<td>视频设备ID, 从1开始</td>
</tr>
<tr>
<td>|--state</td>
<td>number</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "e821bb92-69e2-42c7-9e32-c978fc6be8fb",
  "event": "USER",
  "detailType": 200000,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userInfo": {
      "nickname": "hunter",
      "userName": "hunter",
      "userId": 1610612739,
      "managerState": 0,
      "presenterState": 0,
      "terminalType": 21,
      "audioState": [
        {
          "deviceId": 1,
          "state": 0
        }
      ],
      "videoState": [
        {
          "deviceId": 1,
          "state": 0
        },
        {
          "deviceId": 2,
          "state": 0
        }
      ]
    }
  },
  "timestamp": 1710916323508
}
</code></pre>
<h4>用户离会</h4>
<p>detailType: 200001</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "54998c42-4c56-4d77-81cb-6c4fa55f53d7",
  "event": "USER",
  "detailType": 200001,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0
  },
  "timestamp": 1710916407423
}
</code></pre>
<h4>更新昵称</h4>
<p>detailType: 200002</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>nickname</td>
<td>string</td>
<td>用户昵称</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "56c0bb96-58cb-4af9-971e-e92c825c0a8a",
  "event": "USER",
  "detailType": 200002,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "nickname": ""
  },
  "timestamp": 1710916484223
}
</code></pre>
<h4>变更为管理员</h4>
<p>detailType: 200003</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>managerState</td>
<td>number</td>
<td>0 非管理员状态 2 管理员状态</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "03471c90-5a6c-4c51-b730-32c169999602",
  "event": "USER",
  "detailType": 200003,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "managerState": 0
  },
  "timestamp": 1710916532678
}
</code></pre>
<h4>变更为主讲</h4>
<p>detailType: 200004</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>presenterState</td>
<td>number</td>
<td>0 非主讲状态 2 主讲状态</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "f3136be1-e345-4de7-8073-e1289674b9ff",
  "event": "USER",
  "detailType": 200004,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "presenterState": 0
  },
  "timestamp": 1710916609092
}
</code></pre>
<h4>音频状态变更</h4>
<p>detailType: 200005</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>audioState</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-deviceId</td>
<td>number</td>
<td>设备id 比如第一个设备1, 以此类推</td>
</tr>
<tr>
<td>|-state</td>
<td>string</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "02799a64-6462-4c98-8153-a6ace517dc68",
  "event": "USER",
  "detailType": 200005,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "audioState": {
      "deviceId": 0,
      "state": 0
    }
  },
  "timestamp": 1710916687741
}
</code></pre>
<h4>视频状态变更</h4>
<p>detailType: 200006</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>videoState</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-deviceId</td>
<td>number</td>
<td>设备id 比如第一个设备1, 以此类推</td>
</tr>
<tr>
<td>|-state</td>
<td>string</td>
<td>0 设备未广播状态 1 正在申请广播状态 2 设备广播状态</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "2fac01b9-2310-40f7-b7fc-7a48f58749a1",
  "event": "USER",
  "detailType": 200006,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "videoState": {
      "deviceId": 0,
      "state": 0
    }
  },
  "timestamp": 1710916904603
}
</code></pre>
<h4>音频设备变更</h4>
<p>detailType: 200007</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>audioDevice</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-deviceId</td>
<td>number</td>
<td>设备id 比如第一个设备1, 以此类推</td>
</tr>
<tr>
<td>|-deviceName</td>
<td>string</td>
<td>设备名称</td>
</tr>
<tr>
<td>|-operatorType</td>
<td>number</td>
<td>设备操作类型 1-增加设备 2-修改设备 3-删除设备</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "770059f8-a5e1-45ad-beb0-91952ac2ac4c",
  "event": "USER",
  "detailType": 200007,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "audioDevice": {
      "deviceId": 0,
      "deviceName": "",
      "operatorType": 0
    }
  },
  "timestamp": 1710917072091
}
</code></pre>
<h4>视频设备变更</h4>
<p>detailType: 200008</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>userId</td>
<td>number</td>
<td>用户ID</td>
</tr>
<tr>
<td>videoDevice</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-deviceId</td>
<td>number</td>
<td>设备id 比如第一个摄像头1，第二个摄像头2</td>
</tr>
<tr>
<td>|-deviceName</td>
<td>string</td>
<td>设备名称</td>
</tr>
<tr>
<td>|-operatorType</td>
<td>number</td>
<td>设备操作类型 1-增加设备 2-修改设备 3-删除设备</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "4b11373c-d1ea-4223-b5b1-3e6336239e54",
  "event": "USER",
  "detailType": 200008,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "userId": 0,
    "videoDevice": {
      "deviceId": 0,
      "deviceName": "",
      "operatorType": 0
    }
  },
  "timestamp": 1710917133536
}
</code></pre>
<h3>会议事件</h3>
<h4>会议关闭</h4>
<p>detailType: 201001</p>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "60985bf5-41e3-45bd-81b0-68265691219f",
  "event": "MEETING",
  "detailType": 201001,
  "data": {
    "roomId": 0,
    "meetingId": ""
  },
  "timestamp": 1710917329809
}
</code></pre>
<h4>会议静音</h4>
<p>detailType: 201002</p>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "5e7e5c21-f95d-4140-8961-0d904c3c076b",
  "event": "MEETING",
  "detailType": 201002,
  "data": {
    "roomId": 0,
    "meetingId": ""
  },
  "timestamp": 1710917363150
}
</code></pre>
<h4>会议锁定</h4>
<p>detailType: 201003</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>state</td>
<td>number</td>
<td>0 未锁定 1 锁定</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "b5c60ae9-9826-400d-b13d-ee8164739c83",
  "event": "MEETING",
  "detailType": 201003,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "state": 0
  },
  "timestamp": 1710917426828
}
</code></pre>
<h4>会议布局变更</h4>
<p>detailType: 201004</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>layout</td>
<td>object</td>
<td></td>
</tr>
<tr>
<td>|-mode</td>
<td>number</td>
<td>窗口模式 1 普通模式 2 数据模式 3 视频模式</td>
</tr>
<tr>
<td>|-full</td>
<td>number</td>
<td>是否全屏模式 0 非全屏 1 全屏</td>
</tr>
<tr>
<td>|-dataActive</td>
<td>number</td>
<td>数据当前视图 1 白板 2 屏幕广播 3 WEB共享 4 媒体共享 5 电子投票 6 视频</td>
</tr>
<tr>
<td>|-videoRelayId</td>
<td>number</td>
<td>视频布局ID：1 2 3（画中画） 4 6 9 12 16 25 36 49 64 分屏</td>
</tr>
<tr>
<td>|-fullVideoId</td>
<td>number</td>
<td>视频全屏显示的用户ID</td>
</tr>
<tr>
<td>|-fullVideoMediaId</td>
<td>number</td>
<td>视频全屏用户对应的视频ID</td>
</tr>
<tr>
<td>|-validFullMode</td>
<td>number</td>
<td>保持全屏模式</td>
</tr>
<tr>
<td>|-videoInfo</td>
<td>array</td>
<td>视频信息</td>
</tr>
<tr>
<td>||--userId</td>
<td>number</td>
<td>视频用户ID</td>
</tr>
<tr>
<td>||--mediaId</td>
<td>number</td>
<td>视频通道ID 比如第一个摄像头，id为1，第二个id为2</td>
</tr>
<tr>
<td>||--pos</td>
<td>number</td>
<td>视频显示位置</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "cffff079-48ca-4172-b8bf-1eb289930e25",
  "event": "MEETING",
  "detailType": 201004,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "layout": {
      "mode": 0,
      "full": 0,
      "dataActive": 0,
      "videoRelayId": 0,
      "fullVideoId": 0,
      "fullVideoMediaId": 0,
      "validFullMode": 0,
      "videoInfo": [
        {
          "userId": 0,
          "mediaId": 0,
          "pos": 0
        }
      ]
    }
  },
  "timestamp": 1710917551825
}
</code></pre>
<h4>会议重命名</h4>
<p>detailType: 201005</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>string</td>
<td>会议室名称</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "1b290e66-04cc-4140-9396-78458cb48930",
  "event": "MEETING",
  "detailType": 201005,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "name": ""
  },
  "timestamp": 1710917593336
}
</code></pre>
<h3>录制事件</h3>
<h4>录制状态变更</h4>
<p>detailType: 202001</p>
<table>
<thead>
<tr>
<th>字段</th>
<th>类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>state</td>
<td>number</td>
<td>0.未录制(即停止录制) 2.录制中(开启录制)</td>
</tr>
</tbody>
</table>
<p><strong>示例</strong></p>
<pre><code data-language="json" class="lang-json">{
  "id": "cfeb142b-6c23-494b-9b3b-2ce39698dc47",
  "event": "MEETING",
  "detailType": 202001,
  "data": {
    "roomId": 0,
    "meetingId": "",
    "state": 0
  },
  "timestamp": 1710917628719
}
</code></pre>
<h3 id="-142">请求参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/json</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>路径参数</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>roomId</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> event</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">事件类型: USER; MEETING;RECORD;</span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> address</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">回调接收地址</span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> durable</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap">是否持久化, false 表示只生效单场会议</span></td><td key=5></td></tr>
               </tbody>
              </table>
<h3 id="-143">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>null</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>
<h2 id="u8ba2u9605u67e5u8be20a3ca20id3du8ba2u9605u67e5u8be263553e203ca3e">订阅查询
<a id=订阅查询6355> </a></h2>
<p></p>
<h3 id="-144">基本信息</h3>
<p><strong>Path：</strong> /api/v1/control/subscriptions</p>
<p><strong>Method：</strong> GET</p>
<p><strong>接口描述：</strong></p>
<h3 id="-145">请求参数</h3>
<h3 id="-146">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody"><tr key=0-0><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> code</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-1><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> msg</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2><td key=0><span style="padding-left: 0px"><span style="color: #8c8a8a"></span> data</span></td><td key=1><span>object</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> records</span></td><td key=1><span>object []</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5><p key=3><span style="font-weight: '700'">item 类型: </span><span>object</span></p></td></tr><tr key=0-2-0-0><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> roomId</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-1><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> event</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-2><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> address</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-3><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> durable</span></td><td key=1><span>boolean</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-4><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> status</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-0-5><td key=0><span style="padding-left: 40px"><span style="color: #8c8a8a">├─</span> createTime</span></td><td key=1><span>string</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-1><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> total</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-2><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> size</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-3><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> current</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr><tr key=0-2-4><td key=0><span style="padding-left: 20px"><span style="color: #8c8a8a">├─</span> pages</span></td><td key=1><span>number</span></td><td key=2>非必须</td><td key=3></td><td key=4><span style="white-space: pre-wrap"></span></td><td key=5></td></tr>
               </tbody>
              </table>

            <footer class="m-footer">
              <!-- <p>Build by <a href="https://ymfe.org/">YMFE</a>.</p> -->
            </footer>
          </div>
        </div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped src="./index.css"></style>
<style scoped>
.table-of-contents a {
    padding: 4px 0px;
    display: block;
    text-decoration: none;
}
.table-of-contents {
    position: absolute;
    height: calc(100% - 50px);
    top: 50px;
    left: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    width: 245px;
}
  .content-right {
    max-width: 900px;
    margin-left: 270px;
    padding-left: 40px;
    padding-right: 50px;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    height: 100%;
    overflow: auto;
}
b,strong{
  font-weight: 600;
}
td{
      padding: 5px 10px;
}
</style>
